import _get from 'lodash/get';
import _keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import compact from 'lodash/compact';
import isNull from 'lodash/isNull';
import find from 'lodash/find';
import get from 'lodash/get';
import {
  setDataInStorage,
  removeDataFromStorage,
  getDataFromStorage,
} from '@mmt/legacy-commons/AppState/LocalStorage';
import {
  AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES,
  YEAR_MONTH_DATE_FORMAT,
  irctcAccountUserNameAPI,
  MULTI_SELECT,
  RAILS_FC_TG_SOCIAL_PROOFING,
  CURRENCY_INR,
  ADDON_TYPE_FC,
  ADDON_TYPE_TG,
  GENDER_MALE,
  GENDER_FEMALE,
  GENDER_MALE_TEXT,
  GENDER_FEMALE_TEXT,
  TITLE_MR,
  TITLE_MS,
  TITLE_OTHER,
  TRAVELLER_TYPE_ADULT,
  TRAVELLER_TYPE_CHILD,
  TRAVELLER_TYPE_INFANT,
  BERTH_RESERVED,
  NO_BERTH_RESERVED,
  FULL_TICKET_FULL_BERTH,
} from '@mmt/rails/src/Utils/RailsConstant';
import {
  logTravellersPageLoadPdtEvent,
  logTravellerAdditionalClickEventsWithXDM,
} from 'apps/rails/src/PdtAnalytics/PdtAnalyticsV2/PdtCtRailsListing';
import { crypt } from 'apps/rails/src/Utils/cryptUtils';
import { getJourneyId, buildEnrichedSearchContext } from 'apps/rails/src/PdtAnalytics/PdtAnalyticsV2/PdtV2Utils';
import findIndex from 'lodash/findIndex';
import { Actions } from '../../navigation';
import fecha from 'fecha';
import {
  TGS_Traveller_Container,
  TGS_Tickets_Container
} from '../RIS/PnrStatus/TGSUtils/Constants'
import { getCommonHeaders } from '@mmt/legacy-commons/Helpers/genericHelper';
import {
  getCommonPdtData, getCommonSearchContextData,
} from '../../PdtAnalytics/PdtHelper/RailsPdtUtils.js';
import {
  saveContactDetails,
} from '@mmt/legacy-commons/Common/Components/ContactDetails/contactDetailsUtils';
import { getUserDetails, isUserLoggedIn, shouldShowGSTNWidget} from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import ReservationChoiceType, {
  getRsChoiceByValue,
  ReservationChoiceValuesDefault,
  ReservationChoiceValuesWithoutLowerBerth,
} from '../Constants/ReservationChoiceType';
import {
  getTravelersListFromId,
  loadRailsTravelers,
  loadSelectedTravelersFromCache,
  sortTravelersBySelection,
  storeRailsSelectedTravelersInCache,
  storeRailsTravelersInCache,
  updateTravelerInServer,
} from './Containers/RailsTravelerRepository';
import {
  berthValidation,
  convertDateFormat,
  getInfantCount,
  getMaxTravelersAllowedForBooking,
  getMaxTravelerWarningText,
  getNameObj,
  getSearchKey,
  highlightTravelerForError,
  isAgeAndGenderSpecified,
  isInfant,
  isTravelerSelected,
  showBerthMismatchWarning,
  showBoardingStationChangeOption,
  stringCompare,
  isChild,
  isSrCitizen,
  generateOrUpdateIteneraryId,
} from './TravelerDetailsUtils';
import { showShortToast, showLongToast } from '@mmt/legacy-commons/Common/Components/Toast';
import { getClassType } from '../Types/ClassType';
import railsConfig from '../../RailsConfig';
import {
  DATE_MONTH_YEAR_FORMAT,
  DOUBLE_DIGIT_DAY_WITH_MONTH_FORMAT,
  getDataFromAsynStorage,
  isIRCTCTatkalTime,
  MAX_INFANT_ALLOWED,
  RAILS_IRCTC_SHOW_PASSWORD_REMINDER_SCREEN,
  RAILS_IS_PRE_FC_SELECTED,
  setDataToAsyncStorage,
  TRAVELERS_PAGE_TRACKING_KEY_NEW,
  RAILS_ERROR_RETRY_COUNT,
  TG_LOW_CP_BUCKET_KEY,
  TRAVELLER_PDT_ADDON_DETAILS,
  IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS,
} from '../../Utils/RailsConstant';
import { getHeaderTitleForTravelersAndReview } from '../../Utils/HeaderContentUtil';
import { assuredConfirmationConfigurationApi, getBoardingStation } from '../../Utils/RailsAPIRepository';
import Meal, { getMealPreferenceOptions } from '../Constants/Meal';
import { getMealPreferenceOptions1 } from '../Constants/MealNew';
import Berth, { getBerthPreferenceOptions } from '../Constants/Berth';
import { countries, getNationalityOptions } from '../Constants/Country';
import SrCitizenConcession, { getSrCitizenOptions } from '../Constants/SrCitizenConcession';
import Traveler from './Components/Traveler';
import { backIcon } from '@mmt/legacy-commons/Helpers/displayHelper';
import QuotaType, { isTatkalQuota } from '../Types/QuotaType';
import {
  trackEventAfterRemovingOlderEvent,
  trackTravellerPageEvent,
  trackTravellerSeatInfo,
  trackOdtEvar47or97Event,
  removeEventFromEvar47or97Variable,
  updateEvar47or97Variable,
  trackContactDetailsOnTravelersPage,
  travelerLoadRemoveEvar47or97Events,
  trackGenericEvar47or97Event,
} from '../../railsAnalytics';
import RAIL_EVENTS, { FCTG_TOGETHER } from '../../RailsOmnitureTracker';
import { updateConfigKeyResponseForAadharVerification, updateUsername, updateVerificationFlow } from '../User/UserVerification/UserVerificationActions';
import { fetchBookingReview, getRailsLandingData } from '../Review/RailsReviewActions';
import {
  ACTION_RAILS_LISTING_COMPLETE,
  ACTION_RAILS_LISTING_INIT_STATE,
  ACTION_SET_DATA_FOR_TRAVELERS_PAGE,
  ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
  getAvailabilityResponse,
  getAvlDayList,
  getDefaultAvlStatus,
  getDefaultPostHeaders,
  getDepartureDateAndTime,
  getOrderedQuotaList,
  getQuotaClassRate,
  isBookNowEnabled,
  setLandingData,
  trackEvents,
} from '../NewListing/RailsListingActions';
import {getQuota} from 'apps/rails/src/pages/Types/QuotaType';
import fetch2 from '../../fetch2';
import { addMinutes } from '../NewListing/Utils/RailListingUtils';
import { AbConfigKeyMappings, getPokusConfig } from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import RailsPdtTravellersHelper from '../../PdtAnalytics/PdtHelper/RailsPdtTravellersHelper';
import { deleteTravelerFromServer } from './Containers/RailsUserServiceRepository';
import { defaultTravelInsurance, TRAVEL_INSURANCE } from './TravelerDetails.constant';
import { botmanSensorHeader } from '@mmt/legacy-commons/Native/NetworkModule';
import { getTrainType } from '../Types/TrainTypes';
import { getAddressForDtnCode } from './Containers/RailsAddressRepository';
import { GenderList } from '../Constants/Gender';
import { parseValidateUserResponse, STATUS_API_SUCCESS, STATUS_USER_PROFILE_INCOMPLETE } from '../../Utils/UserRepository';
import { skywalkerSearchConnector } from '../../Skywalker/connector';
import { _label } from '../../vernacular/AppLanguage';
import { bookMode, channelCode, isIos, isMweb } from '../../Utils/device';
import { RAILOFY_TYPE, getTgType } from './railofyUtils';
import {
  getIfToShowFCTGTogether,
  getIfToShowFCTGTogetherPrompt,
  getRailsAvailDepletion,
  getRailsAvailabilitySubscription,
  getRailsTGVersion,
  getTgLowCpBucket,
  getTravelerFreeCancellationBottomSheet,
  getTravellerPdtConfig,
  getRailsFcTgTogetherValue,
  getTravelerRedesignContactDetailsBottomSheetApproach,
  getRailsFcPremiumPokus,
  showSocialProofingFc,
  showSocialProofingTg,
  RailsAbConfig,
  railsCouponExperiment,
} from '../../RailsAbConfig';
import { gstinSubmit } from '@mmt/legacy-commons/Common/Components/GSTIN';
import { setFreeCancellationOption } from '../RailsLandingPage/Store/RailsLandingPageActions';
import { isValidGstNumber } from '@mmt/legacy-commons/Helpers/validationHelpers';
import { uploadGrafanaMetrics } from '../../Utils/RailsGrafanaTracker';
import { getNativeUserDetails } from '../../Utils/CommonUtils';
import { getMmtAuth } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { highlightUserConsentErrorUpdate } from '@mmt/legacy-commons/Common/Components/GSTIN/Store/GSTINactions';
import { getConfigStore } from '../../configStore/Common/RailsConfigStoreUtils';
import { configKeys } from '../../configStore/Common/constants';

export const ACTION_ON_AVAIL_SUBSCRN = '@rails/ACTION_ON_AVAIL_SUBSCRN';
export const ACTION_ON_CONTACT_DETAILS_EDITED = '@rails/ACTION_ON_CONTACT_DETAILS_EDITED';
export const ACTION_ON_LOAD_TRAVELER_PAGE = '@rails/ACTION_ON_LOAD_TRAVELER_PAGE';
export const ACTION_ON_RESERVATION_CHOICE_CLICKED = '@rails/ACTION_ON_RESERVATION_CHOICE_CLICKED';
export const ACTION_USER_DETAILS = '@rails/ACTION_USER_DETAILS';
export const ACTION_ON_VIEW_ALL_CLICKED = '@rails/ACTION_ON_VIEW_ALL_CLICKED';
export const ACTION_ON_TRAVELER_SELECT = '@rails/ACTION_ON_TRAVELER_SELECT';
export const ACTION_SHOW_TRAVELER_COUNT_EXCEED_WARNING =
  '@rails/ACTION_SHOW_TRAVELER_COUNT_EXCEED_WARNING';
export const ACTION_ON_MAX_TRAVELER_SELECTION_LIMIT_EXCEEDED =
  '@rails/ACTION_ON_MAX_TRAVELER_SELECTION_LIMIT_EXCEEDED';
export const ACTION_ON_MAX_TRAVELER_SELECTION_IN_RANGE =
  '@rails/ACTION_ON_MAX_TRAVELER_SELECTION_IN_RANGE';
export const ACTION_ON_INACTIVE_TRAVELER_SELECTED = '@rails/ACTION_ON_INACTIVE_TRAVELER_SELECTED';
export const ACTION_ON_MALE_SELECTED_IN_LADIES_QUOTA =
  '@rails/ACTION_ON_MALE_SELECTED_IN_LADIES_QUOTA';
export const ACTION_SET_TRAVEL_INSURANCE = '@rails/ACTION_SET_TRAVEL_INSURANCE';
export const ACTION_ON_REFUND_AND_CANCELLATION_CLICKED =
  '@rails/ACTION_ON_REFUND_AND_CANCELLATION_CLICKED';
export const ACTION_ON_TRAVEL_ADVISORY_CLICKED = '@rails/ACTION_ON_TRAVEL_ADVISORY_CLICKED';
export const ACTION_ON_CONSIDER_AUTO_UPGRADATION_CLICKED =
  '@rails/ACTION_ON_CONSIDER_AUTO_UPGRADATION_CLICKED';
export const ACTION_ON_BERTH_VALIDATION_FAILURE = '@rails/ACTION_ON_BERTH_VALIDATION_FAILURE';
export const ACTION_ON_BERTH_VALIDATION_SUCCESS = '@rails/ACTION_ON_BERTH_VALIDATION_SUCCESS';
export const ACTION_ON_BERTH_VALIDATION = '@rails/ACTION_ON_BERTH_VALIDATION';
export const ACTION_ON_BERTH_MISMATCH_FOUND = '@rails/ACTION_ON_BERTH_MISMATCH_FOUND';
export const ACTION_INIT_STATE = '@rails/ACTION_INIT_STATE';
export const ACTION_DEFAULT_ACTION = '@rails/ACTION_DEFAULT_ACTION';
export const ACTION_SET_TRAVELER_HEADER = '@rails/ACTION_SET_TRAVELER_HEADER';
export const ACTION_LOAD_BOARDING_STATION = '@rails/ACTION_LOAD_BOARDING_STATION';
export const ACTION_ON_BOARDING_STATION_SELECTED = '@rails/ACTION_ON_BOARDING_STATION_SELECTED';
export const ACTION_LOAD_PREFERENCES = '@rails/ACTION_LOAD_PREFERENCES';
export const ACTION_ON_ADD_EDIT_TRAVELER = '@rails/ACTION_ON_ADD_EDIT_TRAVELER';
export const ACTION_INFANT_COUNT_EXCEEDED = '@rails/ACTION_INFANT_COUNT_EXCEEDED';
export const ACTION_ON_CONTACT_DETAILS_VALIDATION_FAILURE =
  '@rails/ACTION_ON_CONTACT_DETAILS_VALIDATION_FAILURE';
export const ACTION_ON_CAPTURE_REF = '@rails/ACTION_ON_CAPTURE_REF';
export const ACTION_SET_SHOW_PWD_REMINDER_SCREEN = '@rails/ACTION_SET_SHOW_PWD_REMINDER_SCREEN';
export const ACTION_TOGGLE_MODAL_VISIBILITY = '@rails/ACTION_TOGGLE_MODAL_VISIBILITY';
export const ACTION_SET_COUPON_DATA = '@rails/ACTION_SET_COUPON_DATA';
export const ACTION_REMOVE_COUPON_DATA = '@rails/ACTION_REMOVE_COUPON_DATA';
export const ACTION_ON_CONFIRM_BOOK_CHECKBOX_CLICKED =
  '@rails/ACTION_ON_CONFIRM_BOOK_CHECKBOX_CLICKED';
export const ACTION_DELETE_TRAVELLER = '@rails/ACTION_DELETE_TRAVELLER';
export const ACTION_CLEAR_SELECTED_TRAVELRS = '@rails/ACTION_CLEAR_SELECTED_TRAVELRS';
export const ACTION_ADD_RECOMMENDED_COUPONS = 'ACTION_ADD_RECOMMENDED_COUPONS';
export const ACTION_ADD_COUPON_DATA = 'ACTION_ADD_COUPON_DATA';
export const ACTION_ADD_DESTINATION_ADDRESS = 'ACTION_ADD_DESTINATION_ADDRESS';
export const ACTION_SHOW_DUPLICATE_CONFIRMATION = '@rails/ACTION_SHOW_DUPLICATE_CONFIRMATION';
export const ACTION_SHOW_LOADER_FOR_DUPLICATE_AND_REVIEW='@rails/ACTION_SHOW_LOADER_FOR_DUPLICATE_AND_REVIEW';
export const ACTION_SET_BREAK_JOURNEY_DETAILS = '@rails/ACTION_SET_BREAK_JOURNEY_DETAILS';
export const ACTION_REMOVE_BREAK_JOURNEY_DISCLAIMER =
  '@rails/ACTION_REMOVE_BREAK_JOURNEY_DISCLAIMER';
export const ACTION_SHOW_IRCTC_USERNAME_ERROR = '@rails/ACTION_SHOW_IRCTC_USERNAME_ERROR';
export const ACTIONS_OPTED_FOR_FREE_CANCELLATION = '@rails/ACTIONS_OPTED_FOR_FREE_CANCELLATION';
export const ACTIONS_RAILS_ASSURED_CONFIRMATION = '@rails/ACTIONS_RAILS_ASSURED_CONFIRMATION'; // railofy
export const ACTIONS_ADDITIONAL_ASSURED_CONFIRMATION_DETAILS = '@rails/ADDITIONAL_ASSURED_CONFIRMATION_DETAILS';
export const CLEAR_RAILOFY_ZC_OPTED_DETAILS = '@rails/CLEAR_CNFM_DETAILS_ZC_OPTED';
export const ACTION_SAVE_RAILOFY_RESPONSE = '@rails/SAVE_ASSURED_CONFIRMATION_RESPONSE';
export const ACTION_CLEAR_RAILOFY_RESPONSE = '@rails/CLAER_ASSURED_CONFIRMATION_RESPONSE';
export const ACTION_FETCH_RAILOFY_DATA_START = "@rails/ACTION_FETCH_RAILOFY_DATA_START";
export const ACTION_FETCH_RAILOFY_DATA_SUCCESS = "@rails/ACTION_FETCH_RAILOFY_DATA_SUCCESS";
export const ACTION_FETCH_RAILOFY_DATA_FAILED = '@rails/ACTION_FETCH_RAILOFY_DATA_FAILED';
export const ACTION_UPDATE_RAILOFY_USER_RESPONSE = '@rails/ACTION_UPDATE_RAILOFY_USER_RESPONSE';
export const ACTION_SHOW_RAILOFY_WIDGET_ERROR = "@rails/ACTION_SHOW_RAILOFY_WIDGET_ERROR";
export const ACTION_CLEAR_OLD_RAILOFY_DATA = "@rails/ACTION_CLEAR_OLD_RAILOFY_DATA";
export const ACTION_FREE_CANCELLATION_ALERT = '@rails/ACTION_FREE_CANCELLATION_ALERT';
export const BOTTOMSHEET_TOGGLE_CONTACT_DETAILS_ERROR = '@rails/BOTTOMSHEET_TOGGLE_CONTACT_DETAILS_ERROR';
export const PASSENGER_DETAILS_ERROR_ON_TRAVELLER_DETAILS_PAGE = '@rails/PASSENGER_DETAILS_ERROR_ON_TRAVELLER_DETAILS_PAGE';
export const TOGGLE_PASSENGER_DETAILS_BOTTOMSHEET = '@rails/TOGGLE_PASSENGER_DETAILS_BOTTOMSHEET';
export const PASSENGER_DETAILS_TO_BE_EDITED = '@rails/PASSENGER_DETAILS_TO_BE_EDITED';
export const ACTION_DOWNTIME_BOTTOMSHEET = '@rails/ACTION_DOWNTIME_BOTTOMSHEET';
export const ACTION_BOOKING_REVIEW_ERROR_FLOW = '@rails/ACTION_BOOKING_REVIEW_ERROR_FLOW';
export const ACTION_BOOKING_REVIEW_ERROR_FLOW_CODE = '@rails/ACTION_BOOKING_REVIEW_ERROR_FLOW_CODE';
export const ACTION_TG_ALERT = '@rails/ACTION_TG_ALERT';
export const ACTION_UPDATE_FC_TG_USER_RESPONSE = '@rails/ACTION_UPDATE_FC_TG_USER_RESPONSE';
export const ACTION_BNPP_SET_SELECTION = '@rails/ACTION_BNPP_SET_SELECTION';
export const SET_BNPP_INTERACTED = '@rails/SET_BNPP_INTERACTED';
export const UPDATE_OPTIONAL_GST_DETAILS = 'UPDATE_OPTIONAL_GST_DETAILS';
export const ACTION_REVIEW_AVAILABILITY_CHANGE = '@rails/ACTION_REVIEW_AVAILABILITY_CHANGE';
export const ACTION_DISPLAY_AVAIL_DEPLETION_TRAVELER = '@rails/ACTION_DISPLAY_AVAIL_DEPLETION_TRAVELER';
export const ACTION_CLEAR_COUPONS = '@rails/ACTION_CLEAR_COUPONS';

export const ACTION_SET_RAILS_GUEST_SELECTED_TRAVELERS_LIST = '@rails/ACTION_SET_RAILS_GUEST_SELECTED_TRAVELERS_LIST';
export const ACTION_SET_RAILS_GUEST_TRAVELERS_LIST = '@rails/ACTION_SET_RAILS_GUEST_TRAVELERS_LIST';

export const ACTION_SET_RAILS_LOGGED_IN_SELECTED_TRAVELERS_LIST = '@rails/ACTION_SET_RAILS_LOGGED_IN_SELECTED_TRAVELERS_LIST';
export const ACTION_SET_RAILS_LOGGED_IN_TRAVELERS_LIST = '@rails/ACTION_SET_RAILS_LOGGED_IN_TRAVELERS_LIST';
export const FC_TG_BOTTOMSHEET_CTA_CLICKED = '@rails/FC_TG_BOTTOMSHEET_CTA_CLICKED';
export const ACTION_INIT_SCHEDULE_TATKAL_TRAVELER = '@rails/ACTION_INIT_SCHEDULE_TATKAL_TRAVELER';
export const ACTION_SET_IRCTC_PROFILE_STATUS = '@rails/ACTION_SET_IRCTC_PROFILE_STATUS';

export const COMPONENT_TRAVELER = 'traveler';
export const COMPONENT_CONTACT_CARD = 'contact';
export const COMPONENT_TRAVELER_PAGE_SCROLL_VIEW = 'scrollView';
export const COMPONENT_INSURANCE = 'insurance';
export const COMPONENT_DEST_ADDRESSLINE1 = 'destination_address_line1';
export const COMPONENT_DEST_PINCODE = 'destination_pincode';
export const COMPONENT_DEST_POSTOFFICE = 'destination_postoffice';
export const COMPONENT_TRAVEL_ADVISORY = 'travel_advisory';
export const COMPONENT_IRCTC_USERNAME = 'irctc_username';
export const FREE_CANCELLATION = 'FREE_CANCELLATION';
export const ASSURED_CONFIRMATION = 'ASSURED_CONFIRMATION'; // // railofy
export const DUMMY_COMPONENT = 'dummy_component';

let _scrollPos = 0;
export let refs = [];
let _refs = [];

const initWarning = (selectedTravelerList, maxTravelersAllowed, selectedQuota) => {
  const warning = {};
  warning.showChildWithoutBerthWarning =
    selectedTravelerList.length > 0 && berthValidation(selectedTravelerList);

  // last screen GN quota , 6 pax selected, current screen TQ quota
  warning.showMaxTravelerWarningForTatkal = selectedTravelerList.length > maxTravelersAllowed;

  warning.showIrctcTatkalTimeWarning = isTatkalQuota(selectedQuota) && isIRCTCTatkalTime();
  return warning;
};

export const onBoardingStationClicked = (station) => async (dispatch) => {
  trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_BOARDING_POINT_CHANGED);
  try {
    const addOnDetails = (await getDataFromStorage(TRAVELLER_PDT_ADDON_DETAILS)) || [];

    dispatch(
      logTravellerAdditionalClickEventsWithXDM(
        'TRAVELLER_BOARDING_STATION_CHANGE_CLICK',
        undefined,
        undefined,
        addOnDetails,
        { boardingStation: station.obj },
        null,
      ),
    );
  } catch (error) {
    console.error('Error logging boarding station change:', error);
  }

  dispatch({
    type: ACTION_ON_BOARDING_STATION_SELECTED,
    data: {
      selectedPickupStation: station.obj,
    },
  });
};
/* =====Start : Reservation Choice===== */

export const onReservationChoiceClicked = (selectedReservationChoice) => {
  if (selectedReservationChoice.id === '1') {
    trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_SAME_COACH_SELECTED);
  } else if (selectedReservationChoice.id === '2') {
    trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_ADDPREF_ONE_LOWER_BERTH);
  } else if (selectedReservationChoice.id === '3') {
    trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_ADDPREF_TWO_LOWER_BERTH);
  }
  return {
    type: ACTION_ON_RESERVATION_CHOICE_CLICKED,
    data: {
      selectedReservationChoice: getRsChoiceByValue(selectedReservationChoice.id),
    },
  };
};
export const loadReservationChoice = (applicableBerthTypes) => {
  try {
    for (let i = 0; i < applicableBerthTypes.length; i++) {
      if (applicableBerthTypes[i] === 'LB') {
        return ReservationChoiceValuesDefault;
      }
    }
    return ReservationChoiceValuesWithoutLowerBerth;
  } catch (e) {
    console.log('Error in loadReservationChoice : ', e);
  }
};

/* =====End : Reservation Choice===== */

export const loadUserDetails = async (isLoggedIn) => {
  if (!isLoggedIn) {
    return null;
  }
  return getNativeUserDetails();
};

export const clearRecommendedCoupons = () => (dispatch, getState) => {
  dispatch({
    type: ACTION_CLEAR_COUPONS,
    data: { recommendedCoupons: [] },
  });
};

export const onViewAllClicked = () => (dispatch, getState) => {
  const { railsTraveler: { viewAllTravelers } = {} } = getState();
  dispatch({
    type: ACTION_ON_VIEW_ALL_CLICKED,
    data: { viewAllTravelers: !viewAllTravelers },
  });
};

const validateOnSelect = (railsTraveler, traveler) => {
  const { selectedTravelers, maxTravelersAllowed, travelers } = railsTraveler;
  const isSelected = isTravelerSelected(selectedTravelers, traveler);
  const selTravCount = isSelected ? selectedTravelers.length : selectedTravelers.length + 1;
  const infantCount = getInfantCount(selectedTravelers, travelers);
  if (!isAgeAndGenderSpecified(traveler)) {
    return ACTION_ON_INACTIVE_TRAVELER_SELECTED;
  } else if (selTravCount > maxTravelersAllowed) {
    return ACTION_SHOW_TRAVELER_COUNT_EXCEED_WARNING;
  } else if (
    !isSelected &&
    isInfant(traveler.basicInfo.age) &&
    infantCount === MAX_INFANT_ALLOWED
  ) {
    return ACTION_INFANT_COUNT_EXCEEDED;
  } else if (!isSelected && traveler.isMaleTravelingInLadiesQuota) {
    return ACTION_ON_INACTIVE_TRAVELER_SELECTED;
  } else if (traveler.isMaleTravelingInLadiesQuota) {
    return ACTION_ON_MALE_SELECTED_IN_LADIES_QUOTA;
  } else if (!isSelected && traveler.isberthMismatch) {
    return ACTION_ON_BERTH_MISMATCH_FOUND;
  }
  return ACTION_DEFAULT_ACTION;
};

const validateAfterSelect = (railsTraveler, selectedTravelers) => {
  const { travelers, maxTravelersAllowed, warning } = railsTraveler;
  const selectedTravelersList = getTravelersListFromId(selectedTravelers, travelers);

  if (selectedTravelers.length > 0 && berthValidation(selectedTravelersList)) {
    return ACTION_ON_BERTH_VALIDATION_FAILURE;
  } else if (
    warning.showChildWithoutBerthWarning &&
    (selectedTravelers.length === 0 || !berthValidation(selectedTravelersList))
  ) {
    return ACTION_ON_BERTH_VALIDATION_SUCCESS;
  } else if (selectedTravelers.length > maxTravelersAllowed) {
    return ACTION_ON_MAX_TRAVELER_SELECTION_LIMIT_EXCEEDED;
  } else if (selectedTravelers.length <= maxTravelersAllowed) {
    return ACTION_ON_MAX_TRAVELER_SELECTION_IN_RANGE;
  }
  return ACTION_DEFAULT_ACTION;
};

export const onTravelerSelected = (traveler) => async (dispatch, getState) => {
  const { railsTraveler } = getState();
  let { railsTraveler: { selectedTravelers = [], warning, selectedQuota } = {} } = getState();
  if (!warning.showMaxTravelerWarningForTatkal) {
    const actionToDispatchOnSelect = validateOnSelect(railsTraveler, traveler);

    let newTraveler = null;
    switch (actionToDispatchOnSelect) {
      case ACTION_ON_INACTIVE_TRAVELER_SELECTED: {
        // Onselect only
        newTraveler = highlightTravelerForError(traveler, true);
        dispatch({
          type: ACTION_ON_INACTIVE_TRAVELER_SELECTED,
          data: {
            traveler: newTraveler,
          },
        });
        return;
      }
      case ACTION_SHOW_TRAVELER_COUNT_EXCEED_WARNING: {
        showShortToast(getMaxTravelerWarningText(railsTraveler));
        return;
      }
      case ACTION_ON_MALE_SELECTED_IN_LADIES_QUOTA: {
        showShortToast(_label("only_female_passengers"));
        return;
      }
      case ACTION_ON_BERTH_MISMATCH_FOUND: {
        newTraveler = showBerthMismatchWarning(traveler);
        dispatch({
          type: ACTION_ON_BERTH_MISMATCH_FOUND,
          data: {
            traveler: newTraveler,
          },
        });
        break;
      }
      case ACTION_INFANT_COUNT_EXCEEDED: {
        showShortToast(_label("max_infants_allowed", undefined, { count: MAX_INFANT_ALLOWED }));
        return;
      }
      default: {
        newTraveler = null;
      }
    }
  }
  const isSelected = isTravelerSelected(selectedTravelers, traveler);
  if (isSelected) {
    selectedTravelers = filter(selectedTravelers, (value) => value !== traveler.travelerId);
  } else {
    selectedTravelers = [...selectedTravelers, traveler.travelerId];
  }

  const actionToDispatchAfterSelect = validateAfterSelect(
    railsTraveler,
    selectedTravelers,
    selectedQuota,
  );
  switch (actionToDispatchAfterSelect) {
    case ACTION_ON_BERTH_VALIDATION_FAILURE: {
      warning.showChildWithoutBerthWarning = true;
      break;
    }
    case ACTION_ON_BERTH_VALIDATION_SUCCESS: {
      warning.showChildWithoutBerthWarning = false;
      break;
    }
    case ACTION_ON_MAX_TRAVELER_SELECTION_LIMIT_EXCEEDED: {
      warning.showMaxTravelerWarningForTatkal = true;
      break;
    }
    case ACTION_ON_MAX_TRAVELER_SELECTION_IN_RANGE: {
      warning.showMaxTravelerWarningForTatkal = false;
      break;
    }
    default: {
      warning.showMaxTravelerWarningForTatkal = true;
      break;
    }
  }
  await dispatch({
    type: ACTION_ON_TRAVELER_SELECT,
    data: {
      selectedTravelers,
      warning,
    },
  });
  const trvAdditionalPrefFlag = getPokusConfig(
    PokusLobs.RAIL,
    AbConfigKeyMappings.railsTravelerAdditionalPreference,
    true,
  );
  if (trvAdditionalPrefFlag && selectedTravelers && selectedTravelers.length < 2) {
    dispatch({
      type: ACTION_ON_RESERVATION_CHOICE_CLICKED,
      data: {
        selectedReservationChoice: ReservationChoiceType.None,
      },
    });
  }

  await dispatch(reApplyCoupon);
};

export const reApplyCoupon = async (dispatch, getState) => {
  return;
  // console.log('@buddy reapply coupon called');
  // const {railsTraveler: {couponData}} = getState();
  // console.log('@buddy reapply coupon called 2');
  // let couponText = null;
  // if (!couponData || !couponData.couponCode || couponData.status !== 'success') {
  //   return;
  // }
  // else {
  //   couponText = couponData.couponCode;
  // }
  //  dispatch({
  //   type: ACTION_REMOVE_COUPON_DATA,
  //   data: {}
  // });
  //
  // const {
  //   railsTraveler:
  //     {
  //       selectedQuota,
  //       classValue,
  //       totalCollectibleAmount,
  //       selectedTravelers,
  //       travelers
  //     },
  //   railsListing: {
  //     selectedTrainInfo, childBerthMandatory,
  //     seniorCitizenApplicable
  //   },
  //   railsVernacular: {texts}
  // } = getState();
  //
  // const passengerList = getTrvListForCouponApply(selectedTravelers, travelers, selectedQuota, childBerthMandatory, seniorCitizenApplicable);
  // const response = await validateCoupon(couponText, selectedQuota, classValue, selectedTrainInfo, totalCollectibleAmount, passengerList);
  // const error_label = texts.coupon_removed_as_no_longer_applicable || 'Coupon removed as it is no longer applicable';
  // if (!response || response.errorDetails || response.status !== 'success') {
  //   showShortToast(error_label);
  //   trackTravellerPageEvent('mob_rail_travellers_coupon_invalid');
  //   return;
  // }
  // dispatch({
  //   type: ACTION_SET_COUPON_DATA,
  //   data: response
  // });
  // trackTravellerPageEvent('mob_rail_travellers_coupon_success');
};

export const getTravelerHeaderText = () => (disptach, getState) => {
  const {
    railsTraveler: { selectedBookingDate },
    railsListing: { selectedTrainInfo },
  } = getState();

  const titleText = getHeaderTitleForTravelersAndReview(selectedTrainInfo);
  let subtitleText = '';
  try {
    subtitleText = convertDateFormat(
      selectedBookingDate.availablityDate,
      DATE_MONTH_YEAR_FORMAT,
      DOUBLE_DIGIT_DAY_WITH_MONTH_FORMAT,
    );
  } catch (e) {
    console.log('Error in getTravelerHeaderText', e);
  }
  disptach({
    type: ACTION_SET_TRAVELER_HEADER,
    data: {
      header: titleText.concat(' | ').concat(subtitleText),
    },
  });
};

const initState = (
  applicableFoodTypes,
  seniorCitizenApplicable,
  applicableBerthTypes,
  foodChoiceEnabled,
  selectedQuota,
  classValue,
  totalCollectibleAmount,
  showPwdReminder,
  foodDetails,
  totalFare,
  travelerInsuranceOpted,
  originStation,
  destinationStation,
  selectedBookingDate,
  breakJourneyDisclaimer,
  baseFare,
  originalSelectedBookingDate,
) => ({
  type: ACTION_INIT_STATE,
  data: {
    applicableFoodTypes,
    seniorCitizenApplicable,
    applicableBerthTypes,
    foodChoiceEnabled: stringCompare(foodChoiceEnabled, 'true'),
    foodDetails,
    selectedQuota,
    classValue,
    totalCollectibleAmount: parseFloat(totalCollectibleAmount),
    showPwdReminder,
    selectedPickupStation: null,
    couponData: undefined,
    totalFare: parseFloat(totalFare),
    baseFare: parseFloat(baseFare),
    travelerInsuranceOpted,
    originStation,
    destinationStation,
    selectedBookingDate,
    breakJourneyDisclaimer,
    originalSelectedBookingDate,
    isBnppOpted: false,
    reviewAvailablityChange: false,
    bottomSheetCtaClicked: false,
  },
});
const getInitializedContactDetails = (userDetails, contactDetailsBeforeUpdate) => {
  let contactDetails = { name: "", email: "", mobile: "", hasCompleteFields: false, isInternationalNumber: false };
  try {
    if(contactDetailsBeforeUpdate) {
      contactDetails.name = contactDetailsBeforeUpdate.name || contactDetails.name;
      contactDetails.email = contactDetailsBeforeUpdate.email || contactDetails.email;
      contactDetails.mobile = contactDetailsBeforeUpdate.mobile || contactDetails.mobile;
      contactDetails.hasCompleteFields = contactDetailsBeforeUpdate.hasCompleteFields || contactDetails.hasCompleteFields;
      contactDetails.isInternationalNumber = contactDetailsBeforeUpdate.isInternationalNumber || contactDetails.isInternationalNumber;
    }
    if (userDetails) {
      if (userDetails.mobile && userDetails.mobile.mobileNumber) {
        contactDetails.mobile = userDetails.mobile.mobileNumber;
      }
      if (userDetails.email) {
        contactDetails.email = userDetails.email;
      }
      contactDetails.name = compact([userDetails.firstName, userDetails.lastName]).join(' ');
      if(userDetails.mobile && userDetails.mobile.countryCode && Number(userDetails.mobile.countryCode) != 91)
      {
        contactDetails.isInternationalNumber = true;
      }
    }
    contactDetails.hasCompleteFields = !(isEmpty(contactDetails.email) || isEmpty(contactDetails.mobile));
    return contactDetails;
  } catch (e) {
    console.log('error', e);
    return contactDetails;
  }
}


export const initUserDetails = () => async (dispatch,getState) => {
  try {

    // write the clean logic to copy userDetails.mobile.mobileNumber , userDetails.email , userDetails.mobile.countryCode
    const isLoggedIn = await isUserLoggedIn();
    const userDetails = await loadUserDetails(isLoggedIn);
    const {railsTraveler} = getState();
    let contactDetailsBeforeUpdate = (railsTraveler && railsTraveler.contactDetails) ? (railsTraveler.contactDetails) : null;
    let contactDetails = getInitializedContactDetails(userDetails, contactDetailsBeforeUpdate);
    dispatch({
      type: ACTION_USER_DETAILS,
      data: {
        isLoggedIn,
        userDetails,
        contactDetails,
      },
    });
  } catch (e) {
    console.log('error', e);
  }
};


const loadBoardingStation = () => async (dispatch, getState) => {
  let classValue = null;
  let boardingStationList = [];
  let showBoardingStationChange = false;
  let selectedPickupStation = null;
  try {
    const {
      railsListing: { selectedClassType, selectedAvlStatus, selectedTrainInfo },
    } = getState();

    classValue = getClassType(selectedClassType);
    showBoardingStationChange = showBoardingStationChangeOption(selectedAvlStatus);

    if (showBoardingStationChange) {
      boardingStationList = await getBoardingStation(selectedTrainInfo, classValue);
      selectedPickupStation = boardingStationList
        ? selectedTrainInfo.boardingStation
          ? boardingStationList.find(
              (station) => station.stationCode === selectedTrainInfo.boardingStation.code,
            )
          : boardingStationList[0]
        : null;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const confirmedOptions = JSON.parse(urlParams.get('confirmedOptions'));

   if (confirmedOptions) {
      selectedPickupStation =
        boardingStationList.find(
          (station) => station.stationCode === confirmedOptions?.boardingStation?.code,
        ) ?? boardingStationList[0];
    }
    
  } catch (e) {
    console.log('Error in loadBoardingStation :', e);
  }
  dispatch({
    type: ACTION_LOAD_BOARDING_STATION,
    data: {
      classValue,
      showBoardingStationChange,
      boardingStationList,
      selectedPickupStation,
    },
  });
};

const setListingAvailabilityData = async (
  landingData,
  classType,
  trainInfo,
  quotaCode,
  dispatch = null,
) => {
  const { departureDate } = landingData;
  const { avlClasses } = trainInfo || {};
  const response = await getAvailabilityResponse(
    classType,
    trainInfo,
    quotaCode,
    departureDate,
    null,
    null,
    false,
  );
  const { travelplexChatConfig, travelplexTickers } = response?.travelplexConfig || {};

  if (travelplexChatConfig) {
    dispatch({
      type: ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
      data: {
        travelplexChatConfig,
        travelplexTickers,
      },
    });
  }

  if (!isEmpty(response.errorMessage)) {
    throw new Error(_label("something_went_wrong"));
  }

  const { avlDayList, originalAvlDayList } = getAvlDayList(response);
  const formattedDate = fecha.format(departureDate, 'DD-MM-YYYY');
  const selectedAvlStatus = getDefaultAvlStatus(avlDayList, formattedDate);
  const selectedBookingDate = avlDayList[0];
  const {
    insuranceCharge,
    totalCollectibleAmount,
    totalFare,
    baseFare,
    travelAdvisoryDetails,
    applicableFoodTypes,
  } = response;
  if (!isBookNowEnabled(selectedBookingDate)) {
    throw new Error(_label("something_went_wrong"));
  }
  return {
    selectedTrainInfo: trainInfo,
    selectedClassType: classType,
    allAvailableClasses: avlClasses,
    selectedBookingDate,
    selectedAvlStatus,
    avlDayList,
    ...response.bkgCfg,
    insuranceCharge,
    totalCollectibleAmount,
    totalFare,
    baseFare,
    displayStationChangeAlert: false,
    travelAdvisoryDetails,
    originalSelectedBookingDate: originalAvlDayList[0],
    displayConfirmOptionsBottomSheet: false,
    applicableFoodTypes,
  };
};

export const getTrainsListForDeeplink = async (from, to, date) => {
  try {
    const fromCode = from.code;
    const toCode = to.code;
    const deptDate = fecha.format(date, 'YYYYMMDD');
    const searchUrl = `${railsConfig.searchUrlNewListing}/${fromCode}/${toCode}/${deptDate}`;
    const header = await botmanSensorHeader();
    const res = await fetch2(searchUrl, {
      headers: header,
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      if (isEmpty(responseJson)) {
        throw new Error('response json is null');
      }
      if (!isEmpty(responseJson.errorMessage) || !isEmpty(responseJson.error)) {
        throw new Error(_label("something_went_wrong"));
      } else {
        if (isEmpty(responseJson.trainBtwnStnsList)) {
          throw new Error('no trains found');
        }
        const trainsList = responseJson.trainBtwnStnsList.map((train) => {
          const departureDateAndTime = getDepartureDateAndTime(train, date);
          const arrivalDateAndTime = addMinutes(departureDateAndTime, train.duration);
          const cnfOptions = { loading: true, text: null };
          return {
            ...train,
            departureDateAndTime,
            arrivalDateAndTime,
            cnfOptions,
          };
        });
        const { quotaList } = responseJson;
        const trainsListObject = trainsList.reduce((acc, item) => {
          const { avlClasses } = item || {};
          const selectedQuota = QuotaType.GN;
          const quotaClassRate = getQuotaClassRate(quotaList, avlClasses);
          return {
            ...acc,
            [item.trainNumber]: {
              selectedQuota,
              quotaClassRate,
              selectedClassType: avlClasses?.length > 0 ? avlClasses[0] : null,
              selectedDate: null,
              error: false,
              errorMessage: '',
              availabilityResponse: null,
              isLoading: false,
            },
          };
        }, {});

        const availableQuotaList = getOrderedQuotaList(responseJson.quotaList);
        const clientConfig = isEmpty(responseJson.clientConfig)
          ? null
          : responseJson.clientConfig;
        return {
          searchData: trainsList,
          availableQuotaList,
          trainsListObject,
          selectedTrainInfo: null,
          showClassAvailability: false,
          clientConfig,
        };
      }
    }
  } catch (e) {
    console.log('error is 1', e);
    throw new Error(_label("something_went_wrong") + " Error Code: " + e?.errorCode );
  }
};

const setListingDataForTravellers = async (landingData, props, dispatch) => {
  let trainInfo;
  const { originStation, destinationStation, departureDate } = landingData;
  const { trainNumber, classCode: classType, quota: quotaCode, alternate } = props;
  const trainsListData = await getTrainsListForDeeplink(
    originStation,
    destinationStation,
    departureDate,
  );

  trainInfo = trainsListData.searchData.find((item) => item.trainNumber === trainNumber);
  if (alternate) {
    const boardingStation = { code: props.boardingStnCode, name: props.boardingStnName };
    const droppingStation = { code: props.destStnCode, name: props.destStnName };
    trainInfo = {
      ...trainInfo,
      boardingStation,
      droppingStation,
    };
  }
  const listingData = await setListingAvailabilityData(
    landingData,
    classType,
    trainInfo,
    quotaCode,
    dispatch,
  );
  return {
    trainsListData,
    listingData,
  };
};

export const setDataForTravellers = (props) => async (dispatch) => {
  try {
    const { from, to, date, pageSource } = props;
    const departureDate = fecha.parse(date, 'YYYYMMDD');
    const landingData = await getRailsLandingData(from, to, departureDate);
    removeDataFromStorage(TRAVELLER_PDT_ADDON_DETAILS);
    dispatch(setLandingData(landingData));
    const { originStation, destinationStation } = landingData;
    dispatch({
      type: ACTION_RAILS_LISTING_INIT_STATE,
      data: {
        originStation,
        destinationStation,
        departureDate,
        pageSource
      },
    });
    const { trainsListData, listingData } = await setListingDataForTravellers(
      landingData,
      props,
      dispatch,
    );
    dispatch({
      type: ACTION_RAILS_LISTING_COMPLETE,
      data: trainsListData,
    });
    dispatch({
      type: ACTION_SET_DATA_FOR_TRAVELERS_PAGE,
      data: listingData,
    });
    if (props.alternate) {
      trackTravellerPageEvent('mob_rail_travellers_nearby_fromRIS');
    }
    dispatch(trackEvents)
  } catch (e) {
    Actions.rails({
      type: 'replace',
      postPaymentBooking: true,
    });
    showShortToast(_label("something_went_wrong_retry") + " Error Code: " + e?.errorCode );
    console.log('error is 2', e);
  }
};

let _previousTravelersPageLink = null;
export const reviewAvailablityChange = () => {
  return {
    type: ACTION_REVIEW_AVAILABILITY_CHANGE,
    data: { reviewAvailablityChange: true },
  };
};

export const loadTravelerPage = () => async (dispatch, getState) => {
  try {
    if (isMweb()) {
      if (_previousTravelersPageLink === window.location.href) {
        return;
      }
      _previousTravelersPageLink = window.location.href;
    }
    _scrollPos = 0;
    refs = [];
    await setDataToAsyncStorage(RAILS_ERROR_RETRY_COUNT, 0);
    const {
      railsListing: {
        applicableFoodTypes,
        seniorCitizenApplicable,
        applicableBerthTypes,
        foodChoiceEnabled,
        totalCollectibleAmount,
        selectedClassType,
        selectedTrainInfo,
        foodDetails,
        totalFare,
        baseFare,
        selectedBJTrainInfo,
        isBreakJourneySecondLeg,
        departureDate
      },
      railsUserVerification: { irctcUserName },
    } = getState();
     const urlParams = new URLSearchParams(window.location.search);
     let selectedQuota;
     const quota = urlParams.get('quota');
     if (quota) {
       selectedQuota = getQuota(quota);
     } else {
       selectedQuota = getState()?.railsListing?.selectedQuota;
     }
    travelerLoadRemoveEvar47or97Events();
    let { originStation, destinationStation, selectedBookingDate, originalSelectedBookingDate } = getState().railsListing;
    let breakJourneyDisclaimer = null;
    if (selectedBJTrainInfo) {
      originStation = selectedBJTrainInfo.originStation;
      destinationStation = selectedBJTrainInfo.destinationStation;
      selectedBookingDate = selectedBJTrainInfo.selectedBookingDate;
      breakJourneyDisclaimer = selectedBJTrainInfo.breakJourneyDisclaimer;
    }
    await generateOrUpdateIteneraryId(originStation.code, destinationStation.code, departureDate);
    const {railsLanding} = getState();
    const searchContextData = getCommonSearchContextData(railsLanding);
    const data = {
      selectedTrainInfo,
      selectedBookingDate,
      selectedQuota,
      selectedClassType,
      totalCollectibleAmount,
      ...searchContextData
    };
    const classValue = getClassType(selectedClassType);
    let showPwdReminder = false; // await getDataFromStorage(RAILS_IRCTC_SHOW_PASSWORD_REMINDER_SCREEN);
    if (isNull(showPwdReminder)) {
      showPwdReminder = true;
    }

    const travelerInsuranceOpted = defaultTravelInsurance();
    dispatch(
      initState(
        applicableFoodTypes,
        seniorCitizenApplicable,
        applicableBerthTypes,
        foodChoiceEnabled,
        selectedQuota,
        classValue,
        totalCollectibleAmount,
        showPwdReminder,
        foodDetails,
        totalFare,
        travelerInsuranceOpted,
        originStation,
        destinationStation,
        selectedBookingDate,
        breakJourneyDisclaimer,
        baseFare,
        originalSelectedBookingDate,
      ),
    );
    dispatch(showHideIRCTCUsernameError(false));
    dispatch(loadBoardingStation());
    const pdtConfig = await getTravellerPdtConfig();
    if (!pdtConfig) {
      trackPdtTravellersLoad(data);
    }

    if (!irctcUserName) {
      const userName = await irctcAccountUserNameAPI();
      dispatch(updateUsername(userName));
    } else if (irctcUserName) {
      const { railsTraveler: { selectedQuota = null } = {} } = getState() || {};
      const headers = {
        quota: selectedQuota?.code,
      };
      const isValidUserName = await isValidIrctcUserName(irctcUserName, headers);
      if (!isValidUserName) {
        dispatch(updateUsername(null));
      }
    }
    await dispatch(initUserDetails());

    const { railsTraveler } = getState();
    const { psgnDestinationAddress } = railsTraveler;

    // check for session
    const reservationChoice = loadReservationChoice(applicableBerthTypes || []);
    const maxTravelersAllowed = getMaxTravelersAllowedForBooking(selectedQuota);
    const newSearchKey = getSearchKey(originStation, destinationStation);
    let selectedTravelers = [];
    let travelers = [];
    let selectedTravelerList = [];
    if (selectedBJTrainInfo && selectedBJTrainInfo.isSecondLeg === true) {
      const requiredConstants = {
        applicableFoodTypes,
        seniorCitizenApplicable,
        applicableBerthTypes,
        foodChoiceEnabled: stringCompare(foodChoiceEnabled, 'true'),
        selectedQuota,
        classValue,
        maxTravelersAllowed,
        foodDetails,
      };
      const breakJourneyTravellers = getBreakJourneyTravellers(
        requiredConstants,
        selectedBJTrainInfo.travelers,
      );
      travelers = breakJourneyTravellers.travelers;
      selectedTravelers = travelers.map((trav = {}) => trav.travelerId);
      selectedTravelerList = travelers;
    } else {
      if (!isEmpty(newSearchKey) && stringCompare(railsTraveler.searchKey, newSearchKey)) {
        selectedTravelers = loadSelectedTravelersFromCache(railsTraveler, getState);
      } else {
        selectedTravelers = [];
        storeRailsSelectedTravelersInCache(railsTraveler.isLoggedIn, [], dispatch);
      }
      const travelersList = await loadRailsTravelers(railsTraveler, getState, dispatch);

      selectedTravelerList = getTravelersListFromId(selectedTravelers, travelersList);
      travelers = sortTravelersBySelection(travelersList, selectedTravelerList);
    }
    const address = await getAddressForDtnCode(selectedTrainInfo.toStnCode);
    const newaddress = { ...psgnDestinationAddress, ...address };

    const warning = initWarning(selectedTravelerList, maxTravelersAllowed, selectedQuota);


    dispatch({
      type: ACTION_ON_LOAD_TRAVELER_PAGE,
      data: {
        reservationChoice,
        maxTravelersAllowed,
        travelers,
        selectedTravelers,
        warning,
        viewAllTravelers: false,
        travelerInsuranceOpted,
        refundAndCanChecked: true,
        considerAutoUpgradation: false,
        selectedReservationChoice: ReservationChoiceType.None,
        searchKey: newSearchKey,
        showViewAll: travelers.length > 3,
        confirmBookCheckbox: false,
        psgnDestinationAddress: newaddress,
      },
    });

    dispatch(getTravelerHeaderText());
    dispatch(loadPreferences());
    uploadGrafanaMetrics();
    dispatch(fetchRailofyDataIfNeeded());
    // dispatch(showTravelAdvisory(true));
    if (getRailsAvailabilitySubscription() !== 0) {
      dispatch(getAvailabilitySubscription());
    } else {
      trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_NOT_SHOWN);
    }
  } catch (e) {
    console.error('err', e);
  }
};

export const isValidIrctcUserName = (userName, irctcProfileCompletionFlow = false) => async (dispatch, getState) => {
  if (userName) {
    try {
      const { railsTraveler: { selectedQuota = null } = {} } = getState() || {};
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        quota: selectedQuota?.code,
      };
      const res = await fetch2(railsConfig.validateUserId, {
        method: 'POST',
        headers,
        body: JSON.stringify({ userName })
      });
      if (res.status === 200) {
        const response = await res.json();
        const newConfigKey = response?.verificationFlow?.configKey;
        dispatch(updateConfigKeyResponseForAadharVerification(null));
        if (newConfigKey) {
          const configKeyResponse = await getConfigStore(newConfigKey);
          if (!isEmpty(configKeyResponse)) {
            dispatch(updateConfigKeyResponseForAadharVerification(configKeyResponse));
          }
        }
        const userIdStatusObject = parseValidateUserResponse(response);
        dispatch(setShowIrctcProfileCompletionFlow(
          userIdStatusObject.status === STATUS_USER_PROFILE_INCOMPLETE, irctcProfileCompletionFlow));
        dispatch(updateVerificationFlow(response?.verificationFlow ?? {}));
        if (userIdStatusObject.status === STATUS_API_SUCCESS ||
            userIdStatusObject.status === STATUS_USER_PROFILE_INCOMPLETE) {
          handleIrctcUsernameOmniture(userIdStatusObject, irctcProfileCompletionFlow);
          return true;
        }
      }
      return false;
    } catch (e) {
      console.log('error in validating username with irctc.' +"Error Code: "+ e?.errorCode );
      return false;
    }
  }
  return false;
};

export const setShowIrctcProfileCompletionFlow = (val, irctcProfileCompletionFlow = false) => (dispatch) => {
  try {
    dispatch({
      type: ACTION_SET_IRCTC_PROFILE_STATUS,
      data: {
        showProfileIncompleteFlow: val,
        irctcProfileCompletedFromWebView: (irctcProfileCompletionFlow && !val) || false,
      },
    });
  } catch (e) {
    console.error('error in setting irctc profile completion status', e);
  }
};

export const checkIrctcProfileCompletionStatus = () => async (dispatch, getState) => {
  try {
    const { railsUserVerification: { irctcUserName } = {} } = getState() || {};
    dispatch({
      type: ACTION_SET_IRCTC_PROFILE_STATUS,
      data: {
        showIrctcComponentLoader: true,
      }
    });
    await dispatch(isValidIrctcUserName(irctcUserName, true));
    dispatch({
      type: ACTION_SET_IRCTC_PROFILE_STATUS,
      data: {
        showIrctcComponentLoader: false,
      }
    });
  } catch (e) {
    console.error('error in checking irctc profile completion status', e);
  }
};

const handleIrctcUsernameOmniture = (userIdStatusObject, irctcProfileCompletionFlow) => {
  const isProfileIncomplete = userIdStatusObject.status === STATUS_USER_PROFILE_INCOMPLETE;
  const isApiSuccess = userIdStatusObject.status === STATUS_API_SUCCESS;

  const eventKey = isProfileIncomplete
    ? IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS.TRAVELLER.IRCTC_PROFILE_INCOMPLETE_STATUS_EVAR99
    : IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS.TRAVELLER.IRCTC_PROFILE_COMPLETE_STATUS_EVAR99;
  trackGenericEvar47or97Event(TRAVELERS_PAGE_TRACKING_KEY_NEW, eventKey);

  if (!irctcProfileCompletionFlow) return;

  if (isApiSuccess) {
    trackTravellerPageEvent(
      IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS.TRAVELLER.SUCCESSFUL_PROFILE_COMPLETION_CLICK_EVENT
    );
    trackGenericEvar47or97Event(
      TRAVELERS_PAGE_TRACKING_KEY_NEW,
      IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS.TRAVELLER.SUCCESSFUL_PROFILE_COMPLETION_EVAR97_EVENT
    );
  } else {
    trackTravellerPageEvent(
      IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS.TRAVELLER.UNSUCCESSFUL_PROFILE_COMPLETION_CLICK_EVENT
    );
  }
};

export const saveContactCallBackHandler = (contactDetails) => (dispatch) => {
  dispatch({
    type: ACTION_ON_CONTACT_DETAILS_EDITED,
    data: contactDetails,
  });
  saveContactDetails(contactDetails, 'RAILS');
};

export const onAddTraveler = () => (dispatch, getState) => {
  trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_ADD_TRAVELLER);
  const { railsTraveler } = getState();
  if (railsTraveler.selectedTravelers.length < railsTraveler.maxTravelersAllowed) {
    dispatch(togglePassengerDetailsBottomSheet());
    dispatch(passengerToBeEdited());
  } else {
    showShortToast(getMaxTravelerWarningText(railsTraveler));
  }
};

export const togglePassengerDetailsBottomSheet = () => {
  return {
    type: TOGGLE_PASSENGER_DETAILS_BOTTOMSHEET,
    data: null
  }
}

export const passengerToBeEdited = (passengerDetails) => {
  return {
    type: PASSENGER_DETAILS_TO_BE_EDITED,
    data: passengerDetails
  }
}

export const onEditTraveler = (traveler) => (dispatch, getState) => {
  const { railsTraveler } = getState();
  trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_EDIT_TRAVELLER);
  if (
    railsTraveler.selectedTravelers.length < railsTraveler.maxTravelersAllowed ||
    isTravelerSelected(railsTraveler.selectedTravelers, traveler)
  ) {
    dispatch(togglePassengerDetailsBottomSheet());
    dispatch(passengerToBeEdited(traveler));
  } else {
    showShortToast(getMaxTravelerWarningText(railsTraveler));
  }
};

export const onHardBackPress = () => (dispatch, getState) => {
  const { railsTraveler: { travelers, selectedTravelers, isLoggedIn, displayFcBottomSheet} = {} } = getState();
  updateLocalStorage(isLoggedIn, travelers, selectedTravelers, dispatch);
};

export const updateLocalStorage = async (isLoggedIn, travelers, selectedTravelers, dispatch) => {
  try {
    await storeRailsTravelersInCache(isLoggedIn, travelers, dispatch);
    storeRailsSelectedTravelersInCache(isLoggedIn, selectedTravelers, dispatch);
  } catch (e) {
    console.log('Error in updateLocalStorage : ', e);
  }
};

export const onTncClicked = (e) => {
  if (isMweb() && e) {
    e.preventDefault();
  }
  Actions.openWebView({
    url: railsConfig.insuranceTnC,
    headerText: 'Insurance Terms & Conditions',
    headerIcon: backIcon,
  });
};

export const onTravelInsuranceCBClicked = (istravelInsuranceOpted) => (dispatch) => {
  trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_ADD_INSURANCE);
  dispatch({
    type: ACTION_SET_TRAVEL_INSURANCE,
    data: {
      travelerInsuranceOpted: istravelInsuranceOpted,
    },
  });
};

export const onRefundAndCancellationClicked = () => (dispatch, getState) => {
  const { railsTraveler: { refundAndCanChecked } = {} } = getState();
  dispatch({
    type: ACTION_ON_REFUND_AND_CANCELLATION_CLICKED,
    data: {
      refundAndCanChecked: !refundAndCanChecked,
    },
  });
};

export const onTravelAdvisoryClicked = () => (dispatch, getState) => {
  const { railsTraveler: { travelAdvisoryChecked } = {} } = getState();
  dispatch({
    type: ACTION_ON_TRAVEL_ADVISORY_CLICKED,
    data: {
      travelAdvisoryChecked: !travelAdvisoryChecked,
    },
  });
};

export const onConfirmBookCheckboxClicked = () => (dispatch, getState) => {
  const { railsTraveler: { confirmBookCheckbox } = {} } = getState();
  dispatch({
    type: ACTION_ON_CONFIRM_BOOK_CHECKBOX_CLICKED,
    data: {
      confirmBookCheckbox: !confirmBookCheckbox,
    },
  });
};

export const handleGstDetailsChange = (value, dataPoint) => (dispatch) => {
  dispatch({
    type: UPDATE_OPTIONAL_GST_DETAILS,
    data: {
      value,
      dataPoint,
    },
  });
};

export const onConsiderAutoUpgradationClicked = () => (dispatch, getState) => {
  const {
    railsTraveler: { considerAutoUpgradation },
  } = getState();
  dispatch({
    type: ACTION_ON_CONSIDER_AUTO_UPGRADATION_CLICKED,
    data: {
      considerAutoUpgradation: !considerAutoUpgradation,
    },
  });
};

const verifySelectedTravelerInfo = (seletedTravelers) => {
  for (let i = 0; i < seletedTravelers.length; i++) {
    const traveler = seletedTravelers[i];
    if (
      traveler.highlightTravelerForError ||
      traveler.isMaleTravelingInLadiesQuota ||
      !isAgeAndGenderSpecified(traveler)
    ) {
      return false;
    }
  }
  return true;
};

export const verifyTravelerDetails = (selectedTravelers, travelers, maxTravelersAllowed, warning) => {
  try {
    const selectedTravelerList = getTravelersListFromId(selectedTravelers, travelers);

    if (
      selectedTravelers.length !== 0 &&
      selectedTravelers.length <= maxTravelersAllowed &&
      !warning.showChildWithoutBerthWarning &&
      !warning.showMaxTravelerWarningForTatkal &&
      verifySelectedTravelerInfo(selectedTravelerList)
    ) {
      return true;
    }
  } catch (e) {
    console.log('Error in verifyTravelerDetails : ', e);
  }
  return false;
};

export const onTravelerPageScroll = (pos) => {
  _scrollPos = pos;
};

export const getComponentRef = (refs, component) =>
  find(refs, (ref) => ref.component === component);

export const scrollToErrorComponent = (component, refs = _refs) => {
  try {
    const scrollComp = getComponentRef(refs, COMPONENT_TRAVELER_PAGE_SCROLL_VIEW);
    const scrollRef = scrollComp ? scrollComp.ref : null;

    const comp = getComponentRef(refs, component) || getComponentRef(refs, DUMMY_COMPONENT);
    const compRef = comp.ref;

    if (isEmpty(scrollRef)) {
      return ;
    }

    compRef?.measure?.((tfx, tfy, twidth, theight, tpx, tpy) => {
      scrollRef?.getNativeScrollRef?.().measure?.((fx, fy, width, height, px, py) => {
        scrollRef?.scrollTo?.({ y: _scrollPos + tpy - py });
      });
    });
  } catch (error) {
    console.error(error)
  }
};

export const scrollToBottom = (refs = _refs) => {
  const scrollComp = getComponentRef(refs, COMPONENT_TRAVELER_PAGE_SCROLL_VIEW);
  const scrollRef = scrollComp ? scrollComp.ref : null;
  if (scrollRef) {
    scrollRef.scrollToEnd({animated: true});
  }
};

export const toggleModalVisibility = () => ({
  type: ACTION_TOGGLE_MODAL_VISIBILITY,
  data: null,
});

export const showHideIRCTCUsernameError = (val) => ({
  type: ACTION_SHOW_IRCTC_USERNAME_ERROR,
  data: val,
});

export const getDuplicateBookingPayload = (getState) => {
  const {
    railsTraveler: { selectedTravelers, travelers, contactDetails } = {},
    railsListing: { departureDate, selectedTrainInfo } = {},
  } = getState();

  const originStationCode = selectedTrainInfo.frmStnCode;
  const destinationStationCode = selectedTrainInfo.toStnCode;

  const travellersById = _keyBy(travelers, 'travelerId');

  const departureMonth =
    departureDate.getMonth() + 1 < 10
      ? `0${departureDate.getMonth() + 1}`
      : departureDate.getMonth() + 1;
  const departureDate2digit =
    departureDate.getDate() < 10 ? `0${departureDate.getDate()}` : departureDate.getDate();

  return {
    bookerContactDetails: {
      email: contactDetails.email,
      mobileNumber: contactDetails.mobile,
    },
    journeyDetails: {
      tripDetails: {
        journeyDate: `${departureDate.getFullYear()}${departureMonth}${departureDate2digit}`,
        fromStnCode: originStationCode,
        destStnCode: destinationStationCode,
      },
      trainDetails: {
        trainNumber: selectedTrainInfo.trainNumber,
      },
    },
    passengerInfoList: selectedTravelers.map((travId) => {
      const travellerObj = travellersById?.[travId];
      return {
        passengerName: travellerObj?.fullName ?? '',
        passengerGender: travellerObj?.basicInfo?.gender?.value ?? 'M',
      };
    }),
  };
};

export const dismissDuplicateBookingModal = () => (dispatch) => {
  dispatch({
    type: ACTION_SHOW_DUPLICATE_CONFIRMATION,
    data: {},
  });
};

// eslint-disable-next-line max-len
export const onReviewClicked = (psgnDestinationAddress, skipDuplicateBookingCheck, freeCancellation = {}, assuredConfirmation = {}) => async (dispatch, getState) => {
  const {
    railsTraveler: {
      selectedTravelers,
      travelers,
      maxTravelersAllowed,
      warning,
      contactDetails,
      refundAndCanChecked,
      travelerInsuranceOpted,
      classValue,
      selectedQuota,
      optionalGstDetailsEnabled,
      gstDetails: { gstIn, nameOnGst },
    } = {},
    railsUserVerification: { irctcUserName },
  } = getState();

  const {
    railsTraveler,
    gstinReducer,
    railsListing: {
      captureAddress,
      selectedClassType,
      selectedTrainInfo,
      selectedBookingDate
    },
  } = getState();

  const { availablityStatus } = selectedBookingDate ?? {};
  const {trainName, trainNumber} = selectedTrainInfo;
  if (freeCancellation && freeCancellation.freeCancellationEnabled && freeCancellation.freeCancellationData) {
    const { freeCancellationEnabled, optedForFreeCancellation} = freeCancellation;
    dispatch({
      type: ACTIONS_OPTED_FOR_FREE_CANCELLATION,
      data: {
        freeCancellationEnabled,
        freeCancellationInsuranceOpted: optedForFreeCancellation,
        fcVariant: freeCancellation.fcVariant,
      }
    });
  }

  if (assuredConfirmation && assuredConfirmation.railsConfirmationGuaranteeOption && (typeof assuredConfirmation.railofyShown !== 'undefined')) {
    dispatch({
      type: ACTIONS_RAILS_ASSURED_CONFIRMATION,
      data: {
        cnfmGuaranteeDetail: assuredConfirmation,
      },
    });
  }

  if (!irctcUserName) {
      const userName = await irctcAccountUserNameAPI();
    const railsShowIRCTCUsernameInfoMessagesAndPassword = await getPokusConfig(
      PokusLobs.RAIL,
      AbConfigKeyMappings.railsShowIRCTCUsernameInfoMessagesAndPassword,
      true,
    );
    if (!userName) {
      if (railsShowIRCTCUsernameInfoMessagesAndPassword) {
        dispatch(showHideIRCTCUsernameError(true));
        scrollToErrorComponent(COMPONENT_IRCTC_USERNAME, refs);
        showShortToast(_label("enter_irctc_username"));
        return;
      }
      dispatch(toggleModalVisibility());
      return;
    }
    dispatch(updateUsername(userName));
  }


  // verifyDuplicateBooking(getState);

  if (selectedTravelers.length > maxTravelersAllowed) {
    scrollToErrorComponent(COMPONENT_TRAVELER, refs);
    showShortToast(getMaxTravelerWarningText(railsTraveler));
    return;
  }

  if (getInfantCount(selectedTravelers, travelers) > MAX_INFANT_ALLOWED) {
    scrollToErrorComponent(COMPONENT_TRAVELER, refs);
    showShortToast(_label("max_infants_allowed", undefined, { count: MAX_INFANT_ALLOWED }));
    return;
  }

  if (warning.showChildWithoutBerthWarning) {
    scrollToErrorComponent(COMPONENT_TRAVELER, refs);
    showShortToast(_label("irctc_child_berth_restriction"));
    return;
  }

  if (warning.showMaxTravelerWarningForTatkal) {
    scrollToErrorComponent(COMPONENT_TRAVELER, refs);
    showShortToast(getMaxTravelerWarningText(railsTraveler));
    return;
  }

  if (!verifyTravelerDetails(selectedTravelers, travelers, maxTravelersAllowed, warning)) {
    scrollToErrorComponent(COMPONENT_TRAVELER, refs);
    showShortToast(_label("select_valid_traveller"));
    dispatch(showPassengerDetailsError(true));
    return;
  }

  if (isNull(contactDetails) || isEmpty(contactDetails) || !contactDetails.hasCompleteFields) {
    scrollToErrorComponent(COMPONENT_CONTACT_CARD, refs);
    showShortToast(_label("fill_contact_details"));
    const showBottomSheetPokus = getTravelerRedesignContactDetailsBottomSheetApproach();
    if(showBottomSheetPokus){
      trackContactDetailsOnTravelersPage('rails_travellers_cd_prompt_true');
      dispatch(toggleContactDetailsBottomSheet(true));
    } else {
      trackContactDetailsOnTravelersPage('rails_travellers_cd_prompt_false');
      scrollToErrorComponent(COMPONENT_CONTACT_CARD, refs);
      showShortToast(_label("fill_contact_details"));
    }
    return;
  }

  if (captureAddress) {
    if (!psgnDestinationAddress.pinCode) {
      showShortToast(_label("fill_pin_code"));
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.pinCode.match(/^\d{6}$/)) {
      showShortToast("Enter a correct 6-digit pincode");
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.postOffice) {
      showShortToast(_label("invalid_pin_code_error"));
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.postOffice) {
      showShortToast(_label("enter_valid_pincode"));
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.pinCode.match(/^\d{6}$/)) {
      showShortToast("Enter a correct 6-digit pincode");
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.postOffice) {
      showShortToast("Please enter a valid pincode");
      scrollToErrorComponent(COMPONENT_DEST_PINCODE, refs);
      return;
    }
    if (!psgnDestinationAddress.address) {
      showShortToast(_label("fill_address_line", undefined, { line: 1 }));
      scrollToErrorComponent(COMPONENT_DEST_ADDRESSLINE1, refs);
      return;
    }
    if (!psgnDestinationAddress.city) {
      showShortToast(_label("select_city"));
      return;
    }
    if (!psgnDestinationAddress.state) {
      showShortToast(_label("select_state"));
      return;
    }
    // if (!psgnDestinationAddress.postOffice) {
    //   scrollToErrorComponent(COMPONENT_DEST_POSTOFFICE, refs);
    //   showShortToast('Please select Post Office');
    //   return;
    // }
    dispatch({
      type: ACTION_ADD_DESTINATION_ADDRESS,
      data: { psgnDestinationAddress },
    });
  }

  if (!refundAndCanChecked) {
    showShortToast(_label("accept_canc_refund_policy"));
    return;
  }
  if (travelerInsuranceOpted === TRAVEL_INSURANCE.NOT_SELECTED) {
    scrollToErrorComponent(COMPONENT_INSURANCE, refs);
    showShortToast(_label("traveller_insu_choice"));
    return;
  }
  if (travelerInsuranceOpted === TRAVEL_INSURANCE.NONE) {
    dispatch({
      type: ACTION_SET_TRAVEL_INSURANCE,
      data: {
        travelerInsuranceOpted: TRAVEL_INSURANCE.NOT_SELECTED,
      },
    });
    scrollToErrorComponent(COMPONENT_INSURANCE, refs);
    showShortToast(_label("traveller_insu_choice"));
    return;
  }
  trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_CONTINUE);
  const numberOfPassengers = selectedTravelers.length;
  const commonData = `${trainName}|${trainNumber}|${selectedQuota?.code}|${classValue.code}|${availablityStatus}|${numberOfPassengers}`;
  trackTravellerSeatInfo(TRAVELERS_PAGE_TRACKING_KEY_NEW,commonData);

  if (!isMweb()){
    const gstinResponse = await gstinSubmit(gstinReducer);
    if (gstinResponse?.error) {
      dispatch({
        type: ACTION_SHOW_LOADER_FOR_DUPLICATE_AND_REVIEW,
        data: { loadingDuplicateBookingAndReview: false },
      });
      scrollToBottom(refs);
      return;
    }
  } else if (isMweb()) {
    const gstinResponse = await gstinSubmit(gstinReducer);
    if (gstinResponse?.error) {
      dispatch(highlightUserConsentErrorUpdate(true));
      scrollToBottom(refs);
      return;
    }
  }
  const isGSTINwidgetShown = shouldShowGSTNWidget();
  const gstDetailsError =
    optionalGstDetailsEnabled &&
    (!isValidGstNumber(gstIn) || nameOnGst?.slice()?.trim()?.length === 0);
  dispatch(handleGstDetailsChange(gstDetailsError, 'gstDetailsError'));
  if (isGSTINwidgetShown && gstDetailsError) {
    showShortToast(_label('fill_gst_details'));
    scrollToBottom(refs);
    return;
  }
  
  const reviewErrorBSPrioritzationFlow = await reviewErrorBSPrioritzation();
  if (!reviewErrorBSPrioritzationFlow) {
    const bottomSheetShown = await showFcTgBottomSheetIfApplicable(dispatch, railsTraveler);
    if (bottomSheetShown) {
      return;
    }
  }

    // --------- Check duplicate booking start
    if (!skipDuplicateBookingCheck) {
      try {
        const duplicateBookingCheckPayload = getDuplicateBookingPayload(getState);
        dispatch({
          type: ACTION_SHOW_DUPLICATE_CONFIRMATION,
          data: { loading: true },
        });

        dispatch({
          type: ACTION_SHOW_LOADER_FOR_DUPLICATE_AND_REVIEW,
          data: { loadingDuplicateBookingAndReview: true },
        });

        const res = await fetch2(
          'https://railways.makemytrip.com/api/mobile/booking/isDuplicateBooking',
          {
            method: 'POST',
            headers: getCommonHeaders(),
            body: JSON.stringify(duplicateBookingCheckPayload),
          },
        );
        const response = await res.json();
        dispatch({
          type: ACTION_SHOW_DUPLICATE_CONFIRMATION,
          data: { loading: false },
        });
        if (response && response.showAlert) {
          dispatch({
            type: ACTION_SHOW_DUPLICATE_CONFIRMATION,
            data: response,
          });
          return;
        }
      } catch (error) {
        console.log('error isDuplicateBooking', error);
        dispatch({
          type: ACTION_SHOW_LOADER_FOR_DUPLICATE_AND_REVIEW,
          data: { loadingDuplicateBookingAndReview: false },
        });
      }
    }
  // --------- Check duplicate booking End
  if (!irctcUserName) {
      const userName = await irctcAccountUserNameAPI();
    const railsShowIRCTCUsernameInfoMessagesAndPassword = await getPokusConfig(
      PokusLobs.RAIL,
      AbConfigKeyMappings.railsShowIRCTCUsernameInfoMessagesAndPassword,
      true,
    );
    if (!userName) {
      if (railsShowIRCTCUsernameInfoMessagesAndPassword) {
        dispatch(showHideIRCTCUsernameError(true));
        scrollToErrorComponent(COMPONENT_IRCTC_USERNAME, refs);
        showShortToast(_label("enter_irctc_username"));
        return;
      }
      dispatch(toggleModalVisibility());
      return;
    }
    dispatch(updateUsername(userName));
  }

  if (railsTraveler.showPwdReminder) {
    Actions.railsPasswordReminder();
  } else {
    //skywalker start
    //raillisting (selectedClassType)-> selectedTrainInfo -> departureDateAndTime , arrivalDateAndTime, frmStnCode, toStnCode, trainNumber
    try {
      const skyWalkerData = {
        fromCity: selectedTrainInfo.frmStnCode,
        toCity: selectedTrainInfo.toStnCode,
        fromDateTime: fecha.format(selectedTrainInfo.departureDateAndTime, 'DD-MM-YYYY HH:mm:ss'),
        toDateTime: fecha.format(selectedTrainInfo.arrivalDateAndTime, 'DD-MM-YYYY HH:mm:ss'),
        paxCount: railsTraveler.selectedTravelers.length,
        cabinClass: selectedClassType,
        trainNumber: selectedTrainInfo.trainNumber,
      };
      skywalkerSearchConnector(skyWalkerData, 'review');
    } catch (e) {
      console.log('Error in skywalker: ', e);
    }
    //skywalker end
      dispatch(fetchBookingReview());
  }
};

export const reviewErrorBSPrioritzation = async () => {
  try {
    const showReviewError = await getConfigStore(configKeys.RAILS_ERROR_BS_PRIORTY_CONFIG);
    return Boolean(showReviewError?.enabled);
  } catch (error) {
    return false;
  }
};

export const showFcTgBottomSheetIfApplicable = async (dispatch, railsTraveler = {}) => {
  try {
    const {
      railofy: {
        selectedIndex,
        railofyType,
        isFCSelected,
        isTGSelected,
        tripGuaranteeData,
        freeCancellationData,
        fcTgSelectionType,
      } = {},
      bottomSheetCtaClicked,
    } = railsTraveler;

    const showFCTGTogetherPrompt = getIfToShowFCTGTogetherPrompt();
    const fcTgTogetheMultiSelect = fcTgSelectionType === MULTI_SELECT;
    const shouldDisplayFcBottomSheet = (condition, data) => condition && data?.header;
    const shouldDisplayTgBottomSheet = (condition, data) => condition && data?.availabilityText;

    if (
      selectedIndex === -1 &&
      [1, 2].includes(showFCTGTogetherPrompt) &&
      !(isTGSelected || isFCSelected) &&
      !bottomSheetCtaClicked
    ) {
      if (shouldDisplayFcBottomSheet(showFCTGTogetherPrompt === 1, freeCancellationData)) {
        dispatch(displayFcBottomSheet());
        return true;
      } else if (shouldDisplayTgBottomSheet(showFCTGTogetherPrompt === 2, tripGuaranteeData)) {
        dispatch(displayTgBottomSheet());
        return true;
      }
    }

    if (
      selectedIndex !== -1 &&
      fcTgTogetheMultiSelect &&
      !bottomSheetCtaClicked &&
      (isTGSelected || isFCSelected) &&
      !(isTGSelected && isFCSelected)
    ) {
      if (shouldDisplayFcBottomSheet(isTGSelected, freeCancellationData)) {
        dispatch(displayFcBottomSheet());
        return true;
      } else if (shouldDisplayTgBottomSheet(isFCSelected, tripGuaranteeData)) {
        dispatch(displayTgBottomSheet());
        return true;
      }
    }

    if (selectedIndex === -1 && !bottomSheetCtaClicked) {
      if (railofyType === RAILOFY_TYPE.FC) {
        const showFcBottomSheet = getTravelerFreeCancellationBottomSheet();
        if (showFcBottomSheet) {
          dispatch(displayFcBottomSheet());
          return true;
        }
      }
    }
  } catch (e) {
    console.error('FcTgBottomSheet Error', e);
  }

  return false;
};


export const loadPreferences = () => (dispatch, getState) => {
  const { railsTraveler: { applicableBerthTypes, foodDetails, applicableFoodTypes } = {} } = getState();
  let mealOptions2 = {};
  let mealOptions = {};
  let berthOptions = {};
  let srOptions = {};
  let nationalityOptions = {};
  try {
    mealOptions = getMealPreferenceOptions1(applicableFoodTypes);
    berthOptions = getBerthPreferenceOptions(applicableBerthTypes);
    srOptions = getSrCitizenOptions();
    nationalityOptions = getNationalityOptions();
  } catch (e) {
    console.log('Error in loadPreferences :', e);
  }
  dispatch({
    type: ACTION_LOAD_PREFERENCES,
    data: {
      mealOptions,
      berthOptions,
      srOptions,
      nationalityOptions,
    },
  });
};

export const onDeletePassenger = (passengerIdToBeDeleted) => async (dispatch, getState) => {
  const {
    railsTraveler: {
      selectedTravelers,
      travelers,
      maxTravelersAllowed,
      selectedQuota,
      isLoggedIn,
    } = {},
  } = getState();
  try {
    let newSelectedTravelers = selectedTravelers?.filter((value) => value !== passengerIdToBeDeleted);
    let newTravelersList = travelers?.filter(traveler => traveler.travelerId !== passengerIdToBeDeleted);
    const selectedTravelerList = getTravelersListFromId(newSelectedTravelers, newTravelersList);
    newTravelersList = sortTravelersBySelection(newTravelersList, selectedTravelerList);
    
    const warning = initWarning(selectedTravelerList, maxTravelersAllowed, selectedQuota);

    dispatch({
      type: ACTION_ON_ADD_EDIT_TRAVELER,
      data: {
        selectedTravelers: newSelectedTravelers,
        travelers: newTravelersList,
        warning,
        showViewAll: newTravelersList.length > 3,
      },
    });

    updateLocalStorage(isLoggedIn, newTravelersList, newSelectedTravelers);
    dispatch(togglePassengerDetailsBottomSheet());
  } catch (e) {
    console.error('Error in onDeletePassenger : ', e);
  }
  await dispatch(reApplyCoupon);
};

export const onAddEditTraveler = (addTravelerMetaData) => async (dispatch, getState) => {
  const {
    railsTraveler: {
      applicableBerthTypes,
      foodChoiceEnabled,
      selectedQuota,
      classValue,
      selectedTravelers,
      travelers,
      maxTravelersAllowed,
      isLoggedIn,
      userDetails,
      seniorCitizenApplicable,
      applicableFoodTypes,
    } = {},
  } = getState();

  const { traveler, addOrEditFlag } = addTravelerMetaData;
  try {
    const name = getNameObj(traveler.name);
    const newTraveler = new Traveler(
      traveler.travelerId,
      name,
      traveler.age,
      traveler.gender,
      traveler.childBerthFlag,
      applicableBerthTypes,
      foodChoiceEnabled,
      selectedQuota,
      classValue,
      true,
      seniorCitizenApplicable,
      traveler.berth,
      traveler.meal,
      traveler.seniorCitizenConcession,
      traveler.nationality,
      traveler.mealPreferenceArray,
      applicableFoodTypes,
      true,
    );
    if (traveler?.passportNumber) {
      newTraveler.passportNumber = traveler.passportNumber;
    }
    if (traveler?.dateOfBirth) {
      newTraveler.dateOfBirth = traveler?.dateOfBirth;
    }

    const mmtAuth = await getMmtAuth();
    if (isLoggedIn) {
      const savedTraveler = await updateTravelerInServer(newTraveler, mmtAuth, addOrEditFlag);
      if (!isNull(savedTraveler)) {
        newTraveler.travelerId = savedTraveler.travellerId;
        newTraveler.basicInfo.travelerId = savedTraveler.travellerId;
      }
    }

    // Add new/old traveler to selected array
    let newSelectedTravelers = filter(
      selectedTravelers,
      (value) => value !== newTraveler.travelerId,
    );
    newSelectedTravelers = [...newSelectedTravelers, newTraveler.travelerId];

    // Add new/old traveler to travelers array
    let newTravelers = filter(travelers, (value) => value.travelerId !== newTraveler.travelerId);
    newTravelers = [...newTravelers, newTraveler];

    const selectedTravelerList = getTravelersListFromId(newSelectedTravelers, newTravelers);
    newTravelers = sortTravelersBySelection(newTravelers, selectedTravelerList);

    const warning = initWarning(selectedTravelerList, maxTravelersAllowed, selectedQuota);

    dispatch({
      type: ACTION_ON_ADD_EDIT_TRAVELER,
      data: {
        selectedTravelers: newSelectedTravelers,
        travelers: newTravelers,
        warning,
        showViewAll: newTravelers.length > 3,
      },
    });

    updateLocalStorage(isLoggedIn, newTravelers, newSelectedTravelers);
    dispatch(togglePassengerDetailsBottomSheet());
    trackTravellerPageEvent(
      addOrEditFlag
        ? RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_ADD_TRAVELLER_SUCCESS
        : RAIL_EVENTS.TRAVELLER.MOB_RAIL_TRAVELLERS_EDIT_TRAVELLER_SAVED,
    );
  } catch (e) {
    console.log('Error in onAddEditTraveler : ', e);
  }
  await dispatch(reApplyCoupon);
};

export const getBreakJourneyTravellers = (requiredConstants, givenTravellers) => {
  const {
    applicableFoodTypes,
    seniorCitizenApplicable,
    applicableBerthTypes,
    foodChoiceEnabled,
    selectedQuota,
    classValue,
    maxTravelersAllowed,
    foodDetails,
  } = requiredConstants;

  let mealOptions = getMealPreferenceOptions1(applicableFoodTypes);
  let berthOptions = getBerthPreferenceOptions(applicableBerthTypes);
  berthOptions = [...berthOptions, Berth.NO_BERTH_PREF];
  let srOptions = getSrCitizenOptions();
  let nationalityOptions = getNationalityOptions();

  // givenTravellers = [{gender:'F',berthPreference: 'NONE',foodPreference: 'V',seniorCitizenConcession: "true",travellerName: 'Something anything', age: 9, childBerthFlag: true},
  //   {gender:'M', berthPreference: '', foodPreference: 'D',seniorCitizenConcession: 'false', travellerName: 'Canot Remember', age: 62, childBerthFlag: false}];

  let travelers = givenTravellers.map((traveler, index) => {
    const newTraveler = {};
    newTraveler.travelerId = index;
    newTraveler.gender = GenderList.find((g) => g.value === traveler.gender);
    newTraveler.meal = mealOptions.find((meal) => meal.id === traveler.foodPreference) || Meal.NO;
    newTraveler.meal = newTraveler.meal ? newTraveler.meal.obj : Meal.NO;
    newTraveler.nationality = countries.IN;
    newTraveler.name = traveler.travellerName;
    newTraveler.age = traveler.age;
    newTraveler.childBerthFlag = isChild(traveler.age) ? traveler.childBerthFlag : false;
    newTraveler.berth =
      isChild(traveler.age) && !traveler.childBerthFlag
        ? Berth.NO_BERTH_PREF
        : berthOptions.find((berth) => berth.id === traveler.berthPreference) ||
          Berth.NO_BERTH_PREF;
    newTraveler.berth = newTraveler.berth.obj;
    newTraveler.seniorCitizenConcession = !isSrCitizen(traveler.age, traveler.gender)
      ? SrCitizenConcession.NO_CONCESSION
      : srOptions.find((srOpt) => srOpt.id === traveler.seniorCitizenConcession);
    return newTraveler;
  });

  const selectedTravelers = travelers.map((trv) => trv.travelerId);

  travelers = travelers.map((traveler) => {
    const name = getNameObj(traveler.name);
    const newTraveler = new Traveler(
      traveler.travelerId,
      name,
      traveler.age,
      traveler.gender,
      traveler.childBerthFlag,
      applicableBerthTypes,
      foodChoiceEnabled,
      selectedQuota,
      classValue,
      true,
      seniorCitizenApplicable,
      traveler.berth,
      traveler.meal,
      traveler.seniorCitizenConcession,
      traveler.nationality,
    );
    return newTraveler;
  });

  return { travelers, selectedTravelers };
};

export const onContactDetailsValidationFailed = (fieldName) => (dispatch, getState) => {
  let { railsTraveler: { contactDetails } = {} } = getState();
  contactDetails = {
    ...contactDetails,
    hasCompleteFields: false,
    [fieldName]: '',
  };

  dispatch({
    type: ACTION_ON_CONTACT_DETAILS_VALIDATION_FAILURE,
    data: contactDetails,
  });

  saveContactDetails(contactDetails, 'RAILS');
};

// TODO
// if-else block is unnecessary. remove if-else blcok and do sanity
export const captureRef = (componentName, ref) => (dispatch, getState) => {
  let reference = {};
  if (componentName === COMPONENT_TRAVELER) {
    reference = {
      component: COMPONENT_TRAVELER,
      ref,
    };
  } else if (componentName === COMPONENT_INSURANCE) {
    reference = {
      component: COMPONENT_INSURANCE,
      ref,
    };
  } else if (componentName === COMPONENT_IRCTC_USERNAME) {
    reference = {
      component: COMPONENT_IRCTC_USERNAME,
      ref,
    };
  } else if (componentName === COMPONENT_CONTACT_CARD) {
    reference = {
      component: COMPONENT_CONTACT_CARD,
      ref,
    };
  } else if (componentName === COMPONENT_TRAVELER_PAGE_SCROLL_VIEW) {
    reference = {
      component: COMPONENT_TRAVELER_PAGE_SCROLL_VIEW,
      ref,
    };
  } else if (componentName === COMPONENT_DEST_ADDRESSLINE1) {
    reference = {
      component: COMPONENT_DEST_ADDRESSLINE1,
      ref,
    };
  } else if (componentName === COMPONENT_DEST_PINCODE) {
    reference = {
      component: COMPONENT_DEST_PINCODE,
      ref,
    };
  } else if (componentName === COMPONENT_DEST_POSTOFFICE) {
    reference = {
      component: COMPONENT_DEST_POSTOFFICE,
      ref,
    };
  } else if (componentName === COMPONENT_TRAVEL_ADVISORY) {
    reference = {
      component: COMPONENT_TRAVEL_ADVISORY,
      ref,
    };
  } else if (componentName === FREE_CANCELLATION) {
    reference = {
      component: FREE_CANCELLATION,
      ref,
    };
  } else if (componentName === ASSURED_CONFIRMATION) {
    reference = {
      component: ASSURED_CONFIRMATION,
      ref
    };
  }
  else if(componentName === TGS_Traveller_Container)
  {
    reference = {
      component: TGS_Traveller_Container,
      ref
    };
  }
  else if(componentName === TGS_Tickets_Container)
  {
    reference = {
      component: TGS_Tickets_Container,
      ref
    };
  } else if (componentName === DUMMY_COMPONENT) {
    reference = {
      component: DUMMY_COMPONENT,
      ref
    }
  }

  const index = findIndex(refs, (r) => r.component === reference.component);
  if (index !== -1) {
    refs[index] = reference;
  } else {
    refs = [...refs, reference];
  }
  _refs = refs;
};

export const showPasswordReminderScreen = (selected) => async (dispatch) => {
  dispatch({
    type: ACTION_SET_SHOW_PWD_REMINDER_SCREEN,
    data: {
      showPwdReminder: selected,
    },
  });

  await setDataToAsyncStorage(RAILS_IRCTC_SHOW_PASSWORD_REMINDER_SCREEN, selected);
};

export const setCouponData = (couponData) => ({
  type: ACTION_SET_COUPON_DATA,
  data: couponData,
});

export const addCouponToRecommendedList = (couponData) => ({
  type: ACTION_ADD_COUPON_DATA,
  data: couponData,
});

export const addRecommendedCoupons = () => async (dispatch, getState) => {
  const mmtAuth = await getMmtAuth();
  const cmpId = _get(getState(), 'railsLanding.cmp', null);
  const {
    railsListing: {
      selectedTrainInfo,
      selectedQuota,
      selectedClassType,
      totalFare,
      baseFare,
    },
  } = getState();
  const travelStartDate = fecha.format(selectedTrainInfo.departureDateAndTime, 'DD-MM-YYYY');
  const {
    toStnCode: travelDestinationCity,
    frmStnCode: travelDepartureCity,
    trainNumber: trainNo,
  } = selectedTrainInfo;
  const bookingQuota = selectedQuota.value;
  const selectedClass = selectedClassType;
  const trainType = getTrainType(selectedTrainInfo.trainType[0]).id;
  const transactionAmountPreTax = Number(baseFare);
  const transactionAmount = Number(totalFare);

  const body = {
    bookingDevice: channelCode(),
    travelDestinationCity,
    travelStartDate,
    travelDepartureCity,
    travellerCount: 1,
    bookMode: bookMode(),
    trainDetails: [
      {
        trainNo,
        bookingQuota,
        class: selectedClass,
        trainType,
        travelStartDate,
        trainDepartureCity: travelDepartureCity,
        trainDestinationCity: travelDestinationCity,
        transactionAmountPreTax,
        transactionAmount,
      },
    ],
    pokusState: {
      [RailsAbConfig.railsCouponExperiment]: railsCouponExperiment() || 0,
    },
    ...(cmpId && { cmpId }),
  };
  try {
    const promiseRecommendedCoupon = fetch2(railsConfig.recommendCouponURL, {
      body: JSON.stringify(body),
      headers: {
        ...(await getCommonHeaders()),
        Accept: '*/*',
      },
      method: 'POST',
    });
    promiseRecommendedCoupon
      .then((res) => res.json())
      .then((r) => {
        try {
          const coupons = r.couponDetails[body.trainDetails[0].trainNo];
          dispatch({
            type: ACTION_ADD_RECOMMENDED_COUPONS,
            payload: coupons,
          });
        } catch (error) {
          const coupons = [];
          dispatch({
            type: ACTION_ADD_RECOMMENDED_COUPONS,
            payload: coupons,
          });
        }
      });
  } catch (error) {
    const coupons = [];
    dispatch({
      type: ACTION_ADD_RECOMMENDED_COUPONS,
      payload: coupons,
    });
  }
};

/**
 *
 * Pdt related actions
 *
 */

export const trackPdtTravellersLoad = async (data) => {
  const commonPdt = await getCommonPdtData();
  const pdtData = {
    ...commonPdt,
    searchData: data,
  };
  RailsPdtTravellersHelper.trackPageLoad(pdtData);
};

/**
 * Traveler delete action
 * @param {object} traveler
 */
export const onDeleteTravellerAction = (traveler) => async (dispatch, getState) => {
  try {
    const { railsTraveler: { isLoggedIn, selectedTravelers = [] } = {} } = getState();
    if (isLoggedIn) {
      const mmtAuth = await getMmtAuth();
      const payload = {
        query: [
          [
            {
              values: {
                associatedTravellers: [
                  {
                    emergCont: false,
                    status: 'DELETED',
                    travellerId: traveler.travelerId,
                  },
                ],
              },
              name: 'extendedUser',
            },
          ],
        ],
      };
      const response = await deleteTravelerFromServer(payload, mmtAuth); // api call
      if (!response || response.status !== 200) {
        showShortToast(_label("something_went_wrong_retry_or_cancel"));
        return;
      }
    }
    const travelers = _get(getState(), 'railsTraveler.travelers', []);
    const updatedTravelerList = travelers.filter((trv) => trv.travelerId !== traveler.travelerId);
    const updatedTravelersByTravelerId = _keyBy(updatedTravelerList, 'travelerId');
    const newSelectedTravelers = selectedTravelers.filter(
      (trv) => updatedTravelersByTravelerId[trv],
    );
    updateLocalStorage(isLoggedIn, updatedTravelerList, newSelectedTravelers, dispatch);
    dispatch({
      type: ACTION_DELETE_TRAVELLER,
      data: {
        travelers: updatedTravelerList,
        selectedTravelers: newSelectedTravelers,
      },
    });
    await dispatch(reApplyCoupon);
    Actions.pop();
  } catch (err) {
    console.error(err);
    showShortToast(_label("something_went_wrong_retry_or_cancel"));
  }
};

export const clearSelectedTravelersListAction = () => (dispatch, getState) => {
  const { railsTraveler: { isLoggedIn } = {} } = getState();
  dispatch({
    type: ACTION_CLEAR_SELECTED_TRAVELRS,
    data: {
      selectedTravelers: [],
    },
  });
  storeRailsSelectedTravelersInCache(isLoggedIn, [], dispatch);
};

export const removeBreakJourneyDisclaimer = () => async (dispatch, getState) => {
  dispatch({
    type: ACTION_REMOVE_BREAK_JOURNEY_DISCLAIMER,
    data: {},
  });
}

const fetchRailofyDataStart = () => ({
  type: ACTION_FETCH_RAILOFY_DATA_START,
});

const fetchRailofyDataSuccess = (response) => ({
  type: ACTION_FETCH_RAILOFY_DATA_SUCCESS,
  payload: response,
})

const fetchRailofyDataError = (errorResponse) => ({
  type: ACTION_FETCH_RAILOFY_DATA_FAILED,
  payload: errorResponse,
});

export const pdtLoggingTraveller = (response, data) => async (dispatch, getState) => {
  try {
    const state = getState();
    const baseFare = get(state, 'railsListing.baseFare', '');
    const totalFare = get(state, 'railsListing.totalFare', '');
    const totalCollectibleAmount = get(state, 'railsTraveler.totalCollectibleAmount', 0);
    const avlDayList = get(state, 'railsListing.avlDayList[0]', '');
    const boardingStation = get(state, 'railsTraveler.selectedPickupStation', '');

    const { selectedTrainInfo } = state.railsListing;
    const searchContext = await buildEnrichedSearchContext(state);
    const predictionPercentage = selectedTrainInfo?.tbsAvailability?.find(
      (tbs) => tbs.quota === data.quota,
    )?.predictionPercentage;

    const tgVersion = await getRailsTGVersion();
    const reduxFCState = get(state, 'railsLanding.isFreeCancellationEnabled', false);
    const asyncFCState = getIfToShowFCTGTogether() ? await getDataFromAsynStorage(RAILS_IS_PRE_FC_SELECTED) : false;
    const isFCPreSelected = Boolean(reduxFCState || asyncFCState);
    const responseMappings = [
      {
        responseKey: 'confirmationGuaranteeResponse',
        addOnType: ADDON_TYPE_TG,
        id: ADDON_TYPE_TG,
        unitPricePath: 'premiumTextRevamped[1].text',
        refundAmountPath: 'fareInfoRevamped[1].value[0].text',
      },
      {
        responseKey: 'freeCancellationResponse',
        addOnType: ADDON_TYPE_FC,
        id: ADDON_TYPE_FC,
        unitPricePath: 'cancellationOptions[0].insuranceAmount',
        isPreSelected: isFCPreSelected,
        refundAmountPath: 'cancellationOptions[0].refundAmount',
      },
      {
        responseKey: 'bnppResponse',
        addOnType: 'BNPP',
        id: 'BNPP',
        unitPricePath: 'partialAmount',
      },
    ];

    if (tgVersion !== 1 && response.confirmationGuaranteeResponse && response.tgPlusResponse) {
      responseMappings.push({
        responseKey: 'tgPlusResponse',
        addOnType: 'TG_PLUS',
        id: 'TG_PLUS',
        unitPricePath: 'premiumPerPerson',
      });
    }

    const addOnDetails = [];
    for (const mapping of responseMappings) {
      const mappedResponse = get(response, mapping.responseKey, {});

      if (!isEmpty(mappedResponse) && !isNull(mappedResponse)) {
        let unitPrice = get(mappedResponse, mapping.unitPricePath);
        unitPrice = parseFloat(unitPrice.toString().replace(/₹|\/person/g, ''));
        let refundAmount = null;
        if (mapping.refundAmountPath) {
          refundAmount = get(mappedResponse, mapping.refundAmountPath);
          refundAmount = parseFloat(refundAmount?.toString().replace(/₹|\/person/g, ''));
        }

        if (!isNull(unitPrice)) {
          const isFC = mapping.addOnType === ADDON_TYPE_FC;
          const isTG = mapping.addOnType === ADDON_TYPE_TG || mapping.addOnType === 'TG_PLUS';
          
          let selectedValue, isPreselectedValue, includedUnitsValue;
          
          if (isFC) {
            selectedValue = Boolean(isFCPreSelected);
            isPreselectedValue = Boolean(isFCPreSelected);
            includedUnitsValue = isFCPreSelected ? 1 : 0;
          } else if (isTG) {
            selectedValue = false;
            isPreselectedValue = false;
            includedUnitsValue = 0;
          } else {
            selectedValue = null;
            isPreselectedValue = false;
            includedUnitsValue = -1;
          }
          
          const totalPrice = totalCollectibleAmount || baseFare || 1;
          const premiumPercentage = totalPrice > 0 ? Math.round((unitPrice / totalPrice) * 100) : 0;
          
          addOnDetails.push({
            addontype: mapping.addOnType,
            id: mapping.id,
            currency: CURRENCY_INR,
            includedunits: includedUnitsValue,
            unitprice: unitPrice,
            unittype: CURRENCY_INR,
            heading: mapping.addOnType,
            selected: selectedValue,
            available: true,
            is_preselected: isPreselectedValue,
            refund_amount: refundAmount,
            variant: 0,
            premium_percentage: premiumPercentage,
          });
        }
      }
    }

    setDataInStorage(TRAVELLER_PDT_ADDON_DETAILS, addOnDetails);

    const journeyData = await getJourneyId(searchContext);
    const journeyId = journeyData?.journey_id || 'crypt';

    const buildTravellerData = (traveller, index, encryptPII) => {
      const age = parseInt(traveller.basicInfo?.age) || 25;
      const gender = traveller.basicInfo?.gender?.value || traveller.basicInfo?.gender?.key || GENDER_MALE;
      let title = TITLE_OTHER;
      if (gender.toUpperCase() === GENDER_MALE || gender.toUpperCase() === GENDER_MALE_TEXT) {
        title = TITLE_MR;
      } else if (gender.toUpperCase() === GENDER_FEMALE || gender.toUpperCase() === GENDER_FEMALE_TEXT) {
        title = TITLE_MS;
      }
      let type = TRAVELLER_TYPE_ADULT;
      if (age >= 0 && age <= 4) {
        type = TRAVELLER_TYPE_INFANT;
      } else if (age >= 5 && age <= 11) {
        type = TRAVELLER_TYPE_CHILD;
      }
      let reservationType;
      
      if (type === TRAVELLER_TYPE_CHILD || type === TRAVELLER_TYPE_INFANT) {
        reservationType = traveller.basicInfo?.childBerthFlag ? BERTH_RESERVED : NO_BERTH_RESERVED;
      } else {
        reservationType = FULL_TICKET_FULL_BERTH;
      }
      
      const firstName = traveller.basicInfo?.name?.firstName || traveller.fullName?.split(' ')[0] || '';
      const lastName = traveller.basicInfo?.name?.lastName || traveller.fullName?.split(' ').slice(1).join(' ') || '';
      const mobile = get(state, 'railsTraveler.contactDetails.mobile', '') || '';
      const email = get(state, 'railsTraveler.contactDetails.email', '') || '';

      const encrypt = (val) => encryptPII && val ? crypt(journeyId, val) : val;
      
      const travellerObj = {
        is_primary: index === 0,
        fname: encrypt(firstName),
        lname: encrypt(lastName),
        title: encrypt(title),
        mobile_com_id: encrypt(mobile),
        email_com_id: encrypt(email),
        mob_id: encrypt(mobile),
        gender: encrypt(gender),
        type: type,
        age: age.toString(),
        reservation_type: reservationType,
      };
      
      const berthPreference = traveller.basicInfo?.berth?.text;
      const mealPreference = traveller.basicInfo?.meal?.value;
      
      if (berthPreference) {
        travellerObj.berth_preference = berthPreference;
      }
      
      if (mealPreference) {
        travellerObj.meal_preference = mealPreference;
      }
      
      return travellerObj;
    };

    const travelers = get(state, 'railsTraveler.travelers', []);
    const travellerInfo = travelers.map((traveller, index) => buildTravellerData(traveller, index, false));
    const travellerInfoHashed = travelers.map((traveller, index) => buildTravellerData(traveller, index, true));
    
    logTravellersPageLoadPdtEvent(
      'TRAVELLERS_LOAD',
      selectedTrainInfo,
      searchContext,
      addOnDetails,
      { ...data, baseFare, totalFare, ...avlDayList, boardingStation },
      travellerInfo,
      travellerInfoHashed,
    );
  } catch (e) {}
};

export const fetchRailofyDataIfNeeded = (
  hasStatusChangedFCtoTG = false,
  hasStatusChangedTGtoFC = false,
) => {
  return async (dispatch, getState) => {
    removeDataFromStorage(TRAVELLER_PDT_ADDON_DETAILS);
    const state = getState();
    const railofyLoaded = get(state, "railsTraveler.railofy.loaded", false);
    const railofyZcShown = get(state, "railsListing.railofyZcShown", {});
    
    if (hasStatusChangedFCtoTG) {
      railofyZcShown.railofyShown = true;
    } else if (hasStatusChangedTGtoFC) {
      railofyZcShown.railofyShown = false;
      railofyZcShown.zcShown = true;
    }
    const railsFCTogether = await getRailsFcTgTogetherValue();
    removeEventFromEvar47or97Variable(`${FCTG_TOGETHER}1`);
    removeEventFromEvar47or97Variable(`${FCTG_TOGETHER}2`);

    // if (railofyLoaded)s {
    //   return;
    // } @todosfctg update this condition
    dispatch(fetchRailofyDataStart());

    const railsConfirmationGuaranteeOption = get(state, "railsListing.confirmationGuaranteeConfig.railsConfirmationGuaranteeOption", 1);
    const destination = get(state, "railsListing.selectedTrainInfo.toStnCode", {});
    const source = get(state, "railsListing.selectedTrainInfo.frmStnCode", {});
    const classCode = get(state, "railsListing.selectedClassType", "SL");
    const quota = get(state, "railsListing.selectedQuota.code", "GN");
    const doj = get(state, "railsListing.selectedTrainInfo.departureDateAndTime", undefined);
    const departureTime = get(state, 'railsListing.selectedTrainInfo.departureTime', undefined);
    const trainNumber = get(state, "railsListing.selectedTrainInfo.trainNumber", "");

    const data = {
      destination,
      source,
      classCode,
      quota,
      doj: doj ? fecha.format(doj, "YYYYMMDD") : null,
      trainNumber,
      railofyZcShown,
      departureTime,
    };
    const fcUpgradeOption = await getPokusConfig(
      PokusLobs.RAIL,
      AbConfigKeyMappings.showFCUpgradeOption,
      1,
    );
    const pdtConfig = await getTravellerPdtConfig();
    const isFCPreSelected = getIfToShowFCTGTogether() ? await getDataFromAsynStorage(RAILS_IS_PRE_FC_SELECTED) : false;
    const tglowCpBucketValue = getTgLowCpBucket();
    assuredConfirmationConfigurationApi(data, railsConfirmationGuaranteeOption).then((response) => {

      const fcSocialProofing = showSocialProofingFc();
      const tgSocialProofing = showSocialProofingTg();
      const pageName = TRAVELERS_PAGE_TRACKING_KEY_NEW;

      if (fcSocialProofing === 1 || tgSocialProofing === 1) {
        const evarValues = response?.omnitureTracking?.evar97 || [];
        const storedData = getDataFromAsynStorage(RAILS_FC_TG_SOCIAL_PROOFING);
        removeEventFromEvar47or97Variable(storedData);

        if (Array.isArray(evarValues) && evarValues.length > 0) {
          evarValues.forEach((evarValue) => {
            if (evarValue) {
              trackGenericEvar47or97Event(pageName, evarValue);
            }
          });
          setDataToAsyncStorage(RAILS_FC_TG_SOCIAL_PROOFING, evarValues);
        }
      }
      if (
        response?.confirmationGuaranteeResponse !== null ||
        response?.freeCancellationResponse !== null ||
        response?.bnppResponse !== null ||
        response?.tgPlusResponse !== null ||
        response?.availabilityDepletion !== null
      ) {
        if (railsFCTogether === 1 || railsFCTogether === 2) {
          trackOdtEvar47or97Event(
            TRAVELERS_PAGE_TRACKING_KEY_NEW,
            `${FCTG_TOGETHER}${railsFCTogether}`,
          );
        }
        if(
          response?.confirmationGuaranteeResponse &&
          response?.confirmationGuaranteeResponse?.lowCpBucket
        ) {
          trackEventAfterRemovingOlderEvent(
            TRAVELERS_PAGE_TRACKING_KEY_NEW,
            `${TG_LOW_CP_BUCKET_KEY}_${tglowCpBucketValue}`,
            TG_LOW_CP_BUCKET_KEY
          );
          if (!tglowCpBucketValue) {
            response.confirmationGuaranteeResponse = null;
          }
        }

        if (pdtConfig) {
          dispatch(pdtLoggingTraveller(response, data));
        } else {
          dispatch(pdtLoggingTraveller(response, data));
        }
        dispatch(
          fetchRailofyDataSuccess({
            ...response,
            fcUpgradeOption,
            isFCPreSelected,
          }),
        );

        if (!isEmpty(response?.availabilityDepletion) && (getRailsAvailDepletion() === 1 || getRailsAvailDepletion() === 2)) {
          dispatch(changeDisplayAvailDepletionStrip(true));
          switch(getRailsAvailDepletion()) {
            case 1:
              updateEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V1);
              break;
            case 2:
              updateEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V2);
              break;
            default:
              break;
          }
          if (response?.availabilityDepletion?.isDynamicTrain) {
            updateEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_DYNAMIC_TRAIN_PERSAUSION);
          }
          if (response?.availabilityDepletion?.inventorySellOutInDays) {
            trackTravellerPageEvent(
              `${RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_SELLOUT}_${response?.availabilityDepletion?.inventorySellOutInDays}`,
            );
          }
        }
        if (!isEmpty(response?.freeCancellationResponse)) {
          updateEvar47or97Variable(
            `${RAIL_EVENTS.TRAVELLER.RAILS_FC_PREMIUM_EVENT}${getRailsFcPremiumPokus() || 0}`,
          );
        }
        return;
      }
      dispatch(fetchRailofyDataError(response));
    });
  }
}

export const updateRailofyUserResponse = (index, premiumAmount) => {
  return (dispatch, getState) => {
    const {
      railsTraveler: {
        couponData = {},
        railofy: { railofyType },
      },
    } = getState();
    const { fcTgCouponDiscount = {} } = couponData;
    const { successMessage } = fcTgCouponDiscount || {};

    if (successMessage && premiumAmount === 0) {
      dispatch(setCouponData(undefined));
    }
    dispatch({
      type: ACTION_UPDATE_RAILOFY_USER_RESPONSE,
      index,
      premiumAmount,
    });
    if (railofyType === RAILOFY_TYPE.FC){
      setDataToAsyncStorage(RAILS_IS_PRE_FC_SELECTED, premiumAmount > 0);
      dispatch(setFreeCancellationOption(premiumAmount > 0));
    }
  }
};

export const updateFCTGUserResponse =
  (index, premiumAmount, type, toast) => async (dispatch, getState) => {
    let fcTgObj = {};
    const {
      railsTraveler: {
        railofy: {
          cnfmGuaranteeOpted: cnfmGuaranteeOptFlag,
          freeCancellationInsuranceOpted: freeCancellationInsuranceOptedFlag,
          fcTgSelectionType,
          isFcDiscounted,
          isTgDiscounted,
        },
      } = {},
    } = getState();
    const tgVersion = getRailsTGVersion();
    const fcTgTogetheMultiSelect = fcTgSelectionType === MULTI_SELECT;
    const isFCPreSelected = getIfToShowFCTGTogether()
      ? await getDataFromAsynStorage(RAILS_IS_PRE_FC_SELECTED)
      : false;
    fcTgObj.isFCPreSelected = isFCPreSelected;
    switch (type) {
      case RAILOFY_TYPE.TG:
        fcTgObj = {
          cnfmGuaranteeOpted: premiumAmount > 0,
          isTGSelected: premiumAmount > 0,
          isFCSelected: false,
          freeCancellationInsuranceOpted: false,
          isTGPlusSelected: false,
          railofyType: RAILOFY_TYPE.TG,
          tgType: getTgType(RAILOFY_TYPE.TG, tgVersion),
        };
        setDataToAsyncStorage(RAILS_IS_PRE_FC_SELECTED, false);
        if (fcTgTogetheMultiSelect) {
          fcTgObj.freeCancellationInsuranceOpted = !!freeCancellationInsuranceOptedFlag;
          fcTgObj.isFCSelected = !!freeCancellationInsuranceOptedFlag;
          fcTgObj.isFcDiscounted = fcTgObj.cnfmGuaranteeOpted && !isTgDiscounted;
          fcTgObj.isTgDiscounted =
            fcTgObj.freeCancellationInsuranceOpted && !fcTgObj.isFcDiscounted;
        }
        dispatch(setFreeCancellationOption(false));
        break;

      case RAILOFY_TYPE.FC:

        fcTgObj = {
          freeCancellationInsuranceOpted: premiumAmount > 0,
          isFCSelected: premiumAmount > 0,
          isTGSelected: false,
          cnfmGuaranteeOpted: false,
          isTGPlusSelected: false,
          railofyType: RAILOFY_TYPE.FC,
          tgType: getTgType(RAILOFY_TYPE.FC, tgVersion),
        };
        setDataToAsyncStorage(RAILS_IS_PRE_FC_SELECTED, premiumAmount > 0);
        if (fcTgTogetheMultiSelect) {
          fcTgObj.cnfmGuaranteeOpted = !!cnfmGuaranteeOptFlag;
          fcTgObj.isTGSelected = !!cnfmGuaranteeOptFlag;
          fcTgObj.isTgDiscounted = fcTgObj.freeCancellationInsuranceOpted && !isFcDiscounted;
          fcTgObj.isFcDiscounted = fcTgObj.cnfmGuaranteeOpted && !fcTgObj.isTgDiscounted;
        }
        dispatch(setFreeCancellationOption(premiumAmount > 0));
        break;

      case RAILOFY_TYPE.TGP:
        fcTgObj = {
          cnfmGuaranteeOpted: false,
          isTGSelected: false,
          isFCSelected: false,
          freeCancellationInsuranceOpted: false,
          isTGPlusSelected: premiumAmount > 0,
          railofyType: RAILOFY_TYPE.TGP,
          tgType: getTgType(RAILOFY_TYPE.TGP, tgVersion),
        };
        setDataToAsyncStorage(RAILS_IS_PRE_FC_SELECTED, false);
        dispatch(setFreeCancellationOption(false));
        break;

      case RAILOFY_TYPE.TGPV3:
        let isTGPlusSelected = index === 0;
        let isTGSelected = !isTGPlusSelected;
        let railofyType = index === 1 ? RAILOFY_TYPE.TG : RAILOFY_TYPE.TGP;
        let cnfmGuaranteeOpted = index === 1;
        fcTgObj = {
          cnfmGuaranteeOpted,
          isFCSelected: false,
          freeCancellationInsuranceOpted: false,
          isTGSelected,
          isTGPlusSelected,
          railofyType,
          tgType: getTgType(railofyType, tgVersion), // have to fix it
        };
        setDataToAsyncStorage(RAILS_IS_PRE_FC_SELECTED, false);
        dispatch(setFreeCancellationOption(false));
        break;

      default:
        break;
    }

    const toastChecker =
      toast &&
      premiumAmount > 0 &&
      (fcTgObj?.cnfmGuaranteeOpted ||
        fcTgObj?.freeCancellationInsuranceOpted ||
        fcTgObj?.isTGPlusSelected);
    if (toastChecker && !fcTgTogetheMultiSelect) {
      showLongToast(toast);
    }
    dispatch({
      type: ACTION_UPDATE_FC_TG_USER_RESPONSE,
      data: {
        hasError: false,
        selectedIndex: index,
        premiumAmount,
        ...fcTgObj,
      },
    });

};

export const updateFcSelection = (index, premiumAmount) => {
  return (dispatch) => {
    // dispatch(updateRailofyUserResponse(index, premiumAmount));
    dispatch(updateFCTGUserResponse(index, premiumAmount, RAILOFY_TYPE.FC));
    dispatch(closeFcBottomSheet(true));
    dispatch(closeTgBottomSheet(true));
  };
}

export const updateTgSelection = (index, premiumAmount) => {
  return (dispatch) => {
    dispatch(updateFCTGUserResponse(index, premiumAmount, RAILOFY_TYPE.TG));
    dispatch(closeTgBottomSheet(true));
    dispatch(closeFcBottomSheet(true));
  };
};

export const displayFcBottomSheet = () => ({
  type: ACTION_FREE_CANCELLATION_ALERT,
  data: {
    displayFcBottomSheet: true
  }
});

export const closeFcBottomSheet = (bottomSheetCtaClicked = false) => ({
  type: ACTION_FREE_CANCELLATION_ALERT,
  data: {
    displayFcBottomSheet: false,
    bottomSheetCtaClicked,
    }
})

async function checkIrctcUserNameError({irctcUserName, dispatch}) {
  if (!irctcUserName) {
    const userName = await irctcAccountUserNameAPI();
    const railsShowIRCTCUsernameInfoMessagesAndPassword = await getPokusConfig(
        PokusLobs.RAIL,
        AbConfigKeyMappings.railsShowIRCTCUsernameInfoMessagesAndPassword,
        true,
    );
    if (!userName) {
      if (railsShowIRCTCUsernameInfoMessagesAndPassword) {
        dispatch(showHideIRCTCUsernameError(true));
        scrollToErrorComponent(COMPONENT_IRCTC_USERNAME, refs);
        showShortToast(_label("enter_irctc_username"));
        return true;
      }
      dispatch(toggleModalVisibility());
      return true;
    }
    dispatch(updateUsername(userName));
    return true;
  }
  return false;
}


export const showPassengerDetailsError = (val) => {
  return {
    type: PASSENGER_DETAILS_ERROR_ON_TRAVELLER_DETAILS_PAGE,
    data: val,
  }
}


export const toggleContactDetailsBottomSheet = (toggle) => {
  return({
    type: BOTTOMSHEET_TOGGLE_CONTACT_DETAILS_ERROR,
    data: toggle,
})};

export const displayDownTimeBottomSheet = (val) => ({
  type: ACTION_DOWNTIME_BOTTOMSHEET,
  data: {
    displayDownTimeBottomSheet: val,
  },
});

export const displayErrorBottomSheet = (value) => ({
  type: ACTION_BOOKING_REVIEW_ERROR_FLOW,
  data: {
    errorFlow: value,
  },
});


export const setBottomSheetErrorCode = (value) => ({
  type: ACTION_BOOKING_REVIEW_ERROR_FLOW_CODE,
  data: {
    errorFlowCode: value,
  },
});

export const displayTgBottomSheet = () => ({
  type: ACTION_TG_ALERT,
  data: {
    displayTgBottomSheet: true
  },
});

export const closeTgBottomSheet = (bottomSheetCtaClicked = false) => ({
  type: ACTION_TG_ALERT,
  data: {
    displayTgBottomSheet: false,
    bottomSheetCtaClicked,
  },
});

export const setBnppSetSelection = (isBnppOpted) => ({
  type: ACTION_BNPP_SET_SELECTION,
  data: {
    isBnppOpted,
  },
});

export const setBnppInteracted = (bnppInteracted) => ({
  type: SET_BNPP_INTERACTED,
  data: {
    bnppInteracted,
  },
});

export const setRailsGuestSelectedTravelersList = (value) => ({
  type: ACTION_SET_RAILS_GUEST_SELECTED_TRAVELERS_LIST,
  data: {
    railsGuestSelectedTravelersList: value,
  },
});

export const setRailsGuestTravelersList = (value) => ({
  type: ACTION_SET_RAILS_GUEST_TRAVELERS_LIST,
  data: {
    railsGuestTravelersList: value,
  },
});

export const setRailsLoggedInSelectedTravelersList = (value) => ({
  type: ACTION_SET_RAILS_LOGGED_IN_SELECTED_TRAVELERS_LIST,
  data: {
    railsLoggedInSelectedTravelersList: value,
  },
});

export const setRailsLoggedInTravelersList = (value) => ({
  type: ACTION_SET_RAILS_LOGGED_IN_TRAVELERS_LIST,
  data: {
    railsLoggedInTravelersList: value,
  },
});

export const clearTravelerHeaderText = () => (disptach, getState) => {
  disptach({
    type: ACTION_SET_TRAVELER_HEADER,
    data: {
      header: '',
    },
  });
};

export const displayAvailSubscrnBottomSheet = (value) => (dispatch) => {
  dispatch({
    type: ACTION_ON_AVAIL_SUBSCRN,
    data: {
      showAvailSubscrnBottomSheet: value,
    },
  });
};

const fetchAvailabilitySubscription = (actionType) => async (dispatch, getState) => {
  try {
    const {
      railsTraveler: {
        selectedQuota,
        classValue,
        availabilitySubscription: { isAvailSubscrnEnabled } = {},
        selectedBookingDate: { availablityDate, availablityStatus, availablityType } = {},
      } = {},
      railsListing: {
        selectedTrainInfo: { frmStnCode, toStnCode, departureDateAndTime, trainNumber } = {},
      } = {},
    } = getState() || {};
    const body = {
      srcStation: frmStnCode,
      dstnStation: toStnCode,
      departureDate: fecha.format(departureDateAndTime, YEAR_MONTH_DATE_FORMAT),
      trainNumber,
      journeyClass: classValue?.code,
      quota: selectedQuota?.code,
      availabilityDetails: {
        availablityDate,
        availablityStatus,
        availablityType,
      },
      ...(actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE && {
        subscribe: !isAvailSubscrnEnabled,
      }),
    };
    const response = await fetch2(
      actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.INITIALISE
        ? railsConfig.getAvailabilitySubscrnStatus
        : railsConfig.updateAvailabilitySubscrnStatus,
      {
        method: 'POST',
        headers: getDefaultPostHeaders(),
        body: JSON.stringify(body),
      },
    );
    const res = await response.json();
    if (res?.error?.errorMessage && actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE) {
      showShortToast(res?.error?.errorMessage);
      trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_NOT_SHOWN);
    } else if (actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.INITIALISE) {
      dispatch({
        type: ACTION_ON_AVAIL_SUBSCRN,
        data: {
          isAvailSubscrnEnabled: res?.subscriptionDetails?.subscribed || false,
          showSubscriptionWidget: res?.showSubscriptionWidget || false,
        },
      });
      if (!res?.showSubscriptionWidget) {
        trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_NOT_SHOWN);
      } else if (getRailsAvailabilitySubscription() === 1) {
        trackTravellerPageEvent(`${RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_SHOWN}v1`);
      } else {
        trackTravellerPageEvent(`${RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_SHOWN}v2`);
      }
    } else if (
      actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE &&
      res?.subscriptionDetails
    ) {
      dispatch({
        type: ACTION_ON_AVAIL_SUBSCRN,
        data: {
          isAvailSubscrnEnabled: res?.subscriptionDetails?.subscribed || false,
        },
      });
      if (isAvailSubscrnEnabled) {
        trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_UNSUBSCRIBED);
      } else {
        trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_ALERT_SUBSCRIBED);
      }
    }
  } catch (e) {
    showShortToast(_label('something_went_wrong_try_again_later'));
    console.error('Error in fetchAvailabilitySubscription : ', e);
  }
};

export const getAvailabilitySubscription = () => async (dispatch) => {
  dispatch(fetchAvailabilitySubscription(AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.INITIALISE));
};

export const updateAvailabilitySubscription = () => async (dispatch) => {
  dispatch(fetchAvailabilitySubscription(AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE));
};

export const displayAvailDepletionTravelerBottomSheet = (value) => (dispatch) => {
  dispatch({
    type: ACTION_DISPLAY_AVAIL_DEPLETION_TRAVELER,
    data: {
      displayAvailDepletionBottomSheet: value,
    },
  });
  if (value) {
    trackTravellerPageEvent(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_BS_SHOWN);
  }
};

export const changeDisplayAvailDepletionStrip = (value) => (dispatch) => {
  dispatch({
    type: ACTION_DISPLAY_AVAIL_DEPLETION_TRAVELER,
    data: {
      displayAvailDepletionStrip: value,
    },
  });
};
